//#region import
import {
  ActionIcon,
  Box,
  Button,
  CSSProperties,
  Card,
  Checkbox,
  Collapse,
  Divider,
  Flex,
  Grid,
  Group,
  Menu,
  Modal,
  NumberFormatter,
  NumberInput,
  Select,
  Switch,
  Table,
  Tabs,
  Text,
  TextInput,
  Textarea,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import {
  useDebouncedCallback,
  useDebouncedState,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconCreditCard,
  IconDiscount,
  IconEdit,
  IconMaximize,
  IconMaximizeOff,
  IconMenu2,
  IconPlus,
  IconPrinter,
  IconSearch,
  IconTrash,
  IconTruck,
  IconWindow,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as xlsx from "xlsx";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SocketExtension } from "../../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../../_base/socket/ToplicList";
import { styleCellTable } from "../../../_setup/navdata/baseStyleCellTable";
import EditableTextWithOptions from "../../../common/selectValue";
import SelectBuildPc from "../../../common/selectValue/SelectBuildPc";
import SelectPaymentMethod from "../../../common/selectValue/SelectPaymentMethod";
import { _localizationSales } from "../../../config/location";
import { cobalt_blue, orange } from "../../../const/variables";
import { DepartmentModel } from "../../../model/DepartmentModel";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  OrderHeader,
  dataOrderDetailTable,
} from "../../../model/SaleOrderModel";
import { ProductModel } from "../../../model/TblDMItem";
import { TblDMPaymentMethod } from "../../../model/TblDMPaymentMethod";
import {
  ItemDetailPriceModel,
  TblItemPromotionModel,
  itemAddOnPromotionModel,
  itemGiftPromotionModel,
} from "../../../model/TblItem";
import "../../../Styles/TableBodyCell.module.css";
import { LineType, OrderStatus } from "../orderStatus";
import PrintInvoice from "../PrintInvoice";
import axios from "axios";

import {
  containsDT,
  getTotalQuality,
  handleCheckBackgroundColor,
  handleCheckIsSuccessValidateItem,
  handleGetNameBranch,
  handleGetNameDepartment,
  handleKeyDown,
  handlePaymentChange,
  handleQuantityChange,
  parseAttribute19,
} from "../RetailOrder/Helper/HelperFunction";
import ShipCompanyTable from "../RetailOrder/ModalComponent/ChooseShipCompany";
import ChooseShipDepartment from "../RetailOrder/ModalComponent/ChooseShipDepartment";
import CustomerDetail from "../RetailOrder/ModalComponent/CustomerDetail";
import CustomerInformation from "../RetailOrder/ModalComponent/ModalCustomerInformation";
import ModalDeliveryInformation from "../RetailOrder/ModalComponent/ModalDeliveryInformation";
import { PaymentMethod } from "../RetailOrder/ModalComponent/ModalPayment";
import { PaymentMethodMb } from "../RetailOrder/ModalComponent/ModalPaymentMb";
import PaymentDetails from "../RetailOrder/ModalComponent/PaymentDetails";
import VoucherRefactor from "../RetailOrder/ModalComponent/Voucher";
import WarehouseSelector from "../RetailOrder/ModalComponent/WarehouseSelector";
import {
  TableSelectProps,
  customerCheck,
  dataCreateSalesOrder,
} from "../RetailOrder/Model/modelRetailOrder";
import {
  formatDateString,
  formatOrderDate,
  handleCheckChooseProduct,
  handleGetNameEmployeeAll,
  handleGetTechnicialRequireId,
  handleGetTechnicialRequireName,
  handlerRenderOptionSelect,
} from "../ReturnOrder/HelperFunctionReturn";
import styles from "../RetailOrder/RetailOrder.module.css";

const newGuid = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function")
    return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const OrderDetailTMĐT = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFetchDataCalledRef = React.useRef(false);
  const isSetDefaultBuildPc = React.useRef(false);

  // logic chọn lại kho
  const [opened2, setOpened2] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<any>();
  const [warehouseList, setWarehouseList] = useState<any[]>([]);

  //#region   khai báo state
  const [accountantId, setAccountantId] = useState(0);
  const [accountantName, setAccountantName] = useState("");
  const [isPaymentMbSuccess, setIsPaymentMbSuccess] = useState(false);

  const [selectedBank, setSelectedBank] = useState("");
  const [modalType, setModalType] = useState(""); // COD, "Công nợ", "Trả góp"
  const [installmentInfo, setInstallmentInfo] = useState({
    installmentType: "",
    companyName: "",
    contractCode: "",
    cardType: "",
  });

  // State cho thông tin công nợ
  const [debtInfo, setDebtInfo] = useState({
    dueDate: "",
  });

  // Danh sách các ngân hàng (ví dụ)
  const bankOptions = [
    { value: "VCB-930", label: "VCB-930" },
    { value: "TPB-604", label: "TPB-604" },
    { value: "VCB-813", label: "VCB-813" },
    { value: "VCB-762", label: "VCB-762" },
    { value: "PAYOO", label: "PAYOO" },
    { value: "VN PAY", label: "VN PAY" },
    { value: "Alepay", label: "Alepay" },
  ];

  function mapSelectedBank(selectedBank: string): string {
    switch (selectedBank) {
      case "VCB-930":
      case "TPB-604":
      case "VCB-813":
      case "VCB-762":
        return "113201";
      case "PAYOO":
        return "113106";
      case "VN PAY":
        return "113101";
      case "Alepay":
        return "113105";
      default:
        return selectedBank; // Trả lại nguyên nếu không match
    }
  }

  const [transactionCodeReserve, setTransactionCodeReserve] = useState<
    string | null
  >(null); // Mã giao dịch
  const [transactionCodeMb, setTransactionCodeMb] = useState<string | null>(
    null,
  ); // Mã giao dịch MB động
  const [selectedBankReserve, setSelectedBankReserve] = useState<string | null>(
    null,
  ); // Ngân hàng dự phòng
  const [modeSearch, setModeSearch] = useState("SP"); //SP là tìm sản phẩm , DV là tìm dịch vụ
  const [userLogin, setUserLogin] = useState<any>();
  const [listSerial, setListSerial] =
    useState<{ value: string; label: string }[]>();

  // Customer edit modal states
  const [editCustomerModalOpened, setEditCustomerModalOpened] = useState(false);
  const [editCustomerData, setEditCustomerData] = useState({
    name: "",
    telephoneNumber: "",
    address: "",
    provinceId: "",
    wardId: "",
  });
  const [dataProvinces, setDataProvinces] = useState<
    { value: string; label: string }[]
  >([]);
  const [dataWards, setDataWards] = useState<
    { value: string; label: string }[]
  >([]);

  const [totalKM, setTotalKM] = useState(0);
  const [totalKMLine, setTotalKMLine] = useState(0);
  const [totalXGDetail, setTotalXGDetail] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  // phần 5 hàng thanh toán
  const [cashPayment, setCashPayment] = useState(0);
  const [bankTransfer, setBankTransfer] = useState(0);
  const [cardPayment, setCardPayment] = useState(0);
  const [vnpayPayment, setVnpayPayment] = useState(0);
  const [anotherPayment, setAnotherPayment] = useState(0);
  //
  const [totalPaid, setTotalPaid] = useState(0);
  const [deferredPayment, setDeferredPayment] = useState(0);
  const [contractcode, setContractcode] = useState("");
  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);
  const [listBranch, setListBranch] = useState<any[]>([]);
  const [branchId, setBranchId] = useState<number>();
  console.log("branchId", branchId);
  const [branchName, setBranchName] = useState<string>("");
  const [employeeSalesId, setEmployeeSalesId] = useState("");
  const [employeeSalesRevenueId, setEmployeeSalesRevenueId] = useState("");
  const [listDepartment, setListDepartment] = useState<DepartmentModel[]>([]);
  const [departmentId, setDepartmentId] = useState<Number>();
  const [employeeSalesName, setEmployeeSalesName] = useState("");
  const [employeeSalesRevenueName, setEmployeeSalesRevenueName] = useState("");
  const [department, setDepartment] = useState("");
  const [orderStatus, setOrderStatus] = useState<string>("noCreate");
  const [shipping, setShipping] = useState("Nhận tại cửa hàng");
  const [shipingVendor, setShipingVendor] = useState("");
  const [payLaterMethod, setPayLaterMethod] = useState("Không");
  const [saleChanelList, setSaleChanelList] = useState<any[]>();
  const [saleChanelId, setSaleChanelId] = useState<number>();
  const [saleChanel, setSaleChanel] = useState("Khách đến showroom");
  const [height, setHeight] = useState(0);
  const [isError, setIsError] = useState(false);
  const [listAdd, setListAdd] = useState<dataOrderDetailTable[]>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [dataProducts, setDataProducts] = useState<ProductModel[]>([]);
  const [valueDebounced, setValueDebounced] = useDebouncedState("", 500);
  const [paymentDone, setPaymentDone] = useState<string[]>([]);
  const [idPrint, setIdPrint] = useState<number | null>(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [loading, { close: closeLoading, open: openLoading }] =
    useDisclosure(false);
  const [isCollapse, { toggle: toggleCollapse }] = useDisclosure(false);

  //#region  state object
  const [listBuyerName, setListBuyerName] = useState([]);
  const [listAddress, setListAddress] = useState([]);

  const [isHaveShiping, setIsHaveShipping] = useState(false);

  const [dataDeliveryInformation, setDataDeliveryInformation] = useState<any>();
  const [dataPayment, setDataPayment] = useState<any>();
  const [dataPaymentLatter, setDataPaymentLatter] = useState<any>();
  const [orderHeaderRef, setOrderHeaderRef] = useState<any>();
  const [orderHeader, setOrderHeader] = useState<OrderHeader>({
    id: 0, // ID của đơn hàng - OK
    orderNumber: "", // Số đơn hàng - đã ghép vào field "Mã đơn hàng"
    orderTypeId: 2, // Loại đơn hàng (2 là đơn hàng lẻ)
    orderDate: "2024-01-01T01:00:00.000Z", // Ngày đặt hàng - đã ghép vào field "Thời gian"
    orderStatus: "DON_HANG_TAM", // Trạng thái đơn hàng (pending: đang chờ) -đã ghép vào trạng thái góc trên phải
    note: "", // Ghi chú đơn hàng - đã ghép vào field "Ghi chú"
    orgId: 0, // ID tổ chức
    invOrgId: 0, // ID tổ chức liên quan đến kho hàng
    deptId: 0, // ID phòng ban
    divisionId: 0, // ID bộ phận
    saleChanelId: 0, // ID kênh bán hàng
    sourceOrderNumber: "", // Số đơn hàng nguồn
    sourceDocument: "", // Tài liệu nguồn
    sourceInvoices: "", // Hóa đơn nguồn
    custId: 0, // ID khách hàng
    custGroupId: 0, // ID nhóm khách hàng
    contactPersonId: 0, // ID người liên hệ
    billToLocationId: 0, // ID địa điểm hóa đơn
    shipToLocationId: 0, // ID địa điểm giao hàng
    invoiceSerial: "", // Số serial hóa đơn
    invoiceNumber: "", // Số hóa đơn
    invoiceDate: "2024-07-16T04:10:09.167Z", // Ngày hóa đơn
    taxCode: "", // Mã số thuế
    taxAddr: "", // Địa chỉ thuế
    amountTotal: 0, // Tổng số tiền
    amountDiscount: 0, // Số tiền giảm giá
    amountVoucher: 0, // Số tiền voucher
    amountVat: 0, // Số tiền thuế VAT
    currentcyCode: "", // Mã tiền tệ
    currentcyRate: 0, // Tỷ giá tiền tệ
    amountPaid: 0, // Số tiền đã thanh toán
    amountRemaining: 0, // Số tiền còn lại
    paymentType: "", // Loại thanh toán
    paymentStatus: "", // Trạng thái thanh toán
    paymentMethod: "", // Phương thức thanh toán
    paymentDue: 0, // Hạn thanh toán
    saleId: 0, // ID người bán hàng
    managerId: 0, // ID quản lý
    approveId: 0, // ID người duyệt
    approveNote: "", // Ghi chú người duyệt
    rejectNote: "", // Ghi chú từ chối
    shipngType: "", // Loại vận chuyển
    shipingVendor: "", // Nhà cung cấp vận chuyển
    shippingCode: "", // Mã vận chuyển
    shippingStatus: "", // Trạng thái vận chuyển
    shippingPriority: "", // Ưu tiên vận chuyển
    shippingDate: "2024-07-16T04:10:09.167Z", // Ngày vận chuyển
    shippingNote: "", // Ghi chú vận chuyển
    technicalChecked: 0, // Kiểm tra kỹ thuật
    technicalNote: "", // Ghi chú kỹ thuật
    clientId: 0, // ID khách hàng
    createBy: 0, // ID người tạo
    createDate: "2024-07-16T04:10:09.167Z", // Ngày tạo
    lastUpdateBy: 0, // ID người cập nhật cuối cùng
    lastUpdateDate: "2024-07-16T04:10:09.167Z", // Ngày cập nhật cuối cùng
    salesShift: "", // Ca bán hàng
    printInvoiceCheck: 0, // Kiểm tra in hóa đơn
    technicalRequired: 0,
    contractcode: "",
    discountAdded: 0,
    discountAddedTotal: 0,
    orderNumberLink: "",
  });

  const [taxInfo, setTaxInfo] = useState({
    TaxCode: "",
    TaxCompany: "",
    TaxEmail: "",
    TaxAddress: "",
  });
  const [taxInfoModalOpened, setTaxInfoModalOpened] = useState(false);
  const [emailError, setEmailError] = useState<any>("");
  const [timeOutCallApi, setTimeOutCallApi] = useState(false);
  const [vatEmailList, setVatEmailList] = useState("");

  const handleSearchTax = async () => {
    try {
      const response = await axios.get(
        `https://hoadondientu.gdt.gov.vn/api/category/public/dsdkts/${taxInfo?.TaxCode}/manager`,
        {
          headers: {
            "request-id": newGuid(),
          },
        },
      );

      if (response && response.data) {
        const data = response.data;
        const dataAddress = [data?.dctsdchi, data?.dctsxaten, data?.dctstinhten]
          .filter((i) => i && String(i).length > 0)
          .map((i) => String(i).trim())
          .join(", ");

        NotificationExtension.Success("Lấy thông tin MST thành công !");

        const newTaxInfo = {
          ...taxInfo,
          TaxCompany: data.tennnt || "",
          TaxAddress: dataAddress || "",
        };
        setTaxInfo(newTaxInfo);
        setOrderHeader((prev: any) => ({
          ...prev,
          attribute57: JSON.stringify(newTaxInfo),
        }));

        setTimeout(() => {
          setTimeOutCallApi(false);
        }, 1000); // Ngăn click liên tục
      }
    } catch (error: any) {
      if (error?.response?.data?.message) {
        NotificationExtension.Warn(error?.response?.data?.message);
      }
      setTimeOutCallApi(false);
    }
  };

  const [customerCheck, setCustomerCheck] = useState<customerCheck>({
    id: 0,
    companyName: null,
    code: null,
    name: null,
    contact: null,
    address: null,
    telephoneNumber: null,
    fax: null,
    email: null,
    taxCode: "",
    type: null,
    active: null,
    description: null,
    sex: null,
    groupId: 0,
    country: null,
    province: null,
    district: null,
    commune: null,
    provinceName: null,
    districtName: null,
    communeName: null,
    birthOfDate: null,
    groupName: null,
    debtLimit: null,
    debtTerm: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
  });

  const [dataAllocate, setDataAllocate] = useState([]);
  const [isDisablePhanBo, setIsDisablePhanBo] = useState(false);

  const deliveryFee =
    listAdd.length > 0 ? dataDeliveryInformation?.deliveryFee || 0 : 0;
  const calculateKmPerLine = (item: dataOrderDetailTable) => {
    const lineType = item?.lineTyle;
    if (!["HH", "DV", "HT"].includes(lineType || "")) return 0;

    const price = Number(item?.priceOnPriceList) || 0;
    const quantity = Number(item?.quality) || 1;
    const discountRate = Number(item?.discountRate) || 0;
    const discountAmount = Number(item?.discountAmount) || 0;
    const discountByRate = (discountRate * price) / 100;

    return Math.round((discountAmount + discountByRate) * quantity) || 0;
  };

  const totalPromotionOrder =
    listAdd?.reduce(
      (acc: number, item: dataOrderDetailTable) =>
        acc + calculateKmPerLine(item),
      0,
    ) || 0;
  const displayTotalAmount =
    containsDT(orderHeader?.orderNumber) &&
    location?.state?.actionType !== "doi"
      ? Number(orderHeader?.amountTotal) || 0
      : Number(totalAmount) || 0;
  const amountAfterDiscount = Math.max(
    displayTotalAmount - totalPromotionOrder,
    0,
  );
  const totalFloorFee = Number(orderHeader?.amountDiscountTotal ?? 0) || 0;
  const floorFeeAfter =
    Number(orderHeader?.attributevalue7 ?? orderHeader?.attributeValue7 ?? 0) ||
    0;

  //#region handle FUNC

  const handleSelectShipingVendor = (value: any) => {
    setShipingVendor(value?.DoiTacVanChuyen);
  };
  const handleRenderOptionListAdd = (
    listAdd: any[],
  ): { value: string; label: string }[] => {
    return listAdd
      .filter((item) => item.lineTyle === "HT" && item.attribute13)
      .map((item) => ({
        value: item.attribute13,
        label: item.attribute13,
      }));
  };

  const isDisableHoanThanh = () => {
    if (!orderHeader?.amountDiscountTotal && !orderHeader?.discountAddedTotal) {
      return false;
    }

    if (listAdd.length === 0) return true;

    const sumAttr28 = listAdd.reduce(
      (sum, item) => sum + (Number(item.attribute28) ?? 0),
      0,
    );
    const sumAttr29 = listAdd.reduce(
      (sum, item) => sum + (Number(item.attribute29) ?? 0),
      0,
    );

    return sumAttr28 === 0 && sumAttr29 === 0;
  };

  const saveLogToLocalStorage = () => {
    // Kiểm tra điều kiện: amountDiscountTotal > 0 hoặc discountAddedTotal > 0
    if (
      !(
        (orderHeader?.amountDiscountTotal ?? 0) > 0 ||
        (orderHeader?.discountAddedTotal ?? 0) > 0
      )
    ) {
      return; // Không thỏa điều kiện => không lưu
    }

    const logData = {
      tblOrderDetails: dataAllocate?.length > 0 ? listAdd : [],
      orderNumber: orderHeader?.orderNumber ?? null,
    };

    // Lấy log cũ từ localStorage
    const existingLogsString = localStorage.getItem("orderLog");
    const existingLogs = existingLogsString
      ? JSON.parse(existingLogsString)
      : [];

    // Thêm log mới
    existingLogs.push(logData);

    // Lưu lại
    localStorage.setItem("orderLog", JSON.stringify(existingLogs));
  };

  const handleApprovedSalesOrder = async () => {
    if (!orderHeader.custId) {
      NotificationExtension.Warn("Chưa có thông tin khách hàng !");
      return;
    }
    const response = await repositoryPos.post<
      MessageResponse<dataCreateSalesOrder>
    >("/api/v1/CreateSellItem/approve", {
      orderDetail: listAdd,
      orderHeader: {
        ...orderHeader,
        invOrgId: branchId ? branchId : 488,
        orgId: branchId ? branchId : 488,
        saleChanelId: saleChanelId ? saleChanelId : 67,
        saleId: employeeSalesId,
        deptId: departmentId,
        attribute2: accountantId, //Nguyễn Trang Quyên-0009
        contractcode: contractcode,
        orderTypeId: location?.state?.orderType || 2,
        branchId: branchId ? branchId : 488,
        amountTotal: payableAmount,
        amountDiscount: totalKMLine,
        amountVat: 0,
        discountAdded: totalXGDetail,
        attribute1: JSON.stringify(dataDeliveryInformation),
        createDate: orderHeader?.orderDate,
        approveStatus: "2",
      },
      isApprove: true,
    });

    if (response && response.success) {
      setOrderStatus("DON_HANG_DA_DUYET_GIAM");
      NotificationExtension.Success("Duyệt giảm giá thành công !");
      SocketExtension.SendMessageToTopic<any>({
        topic: CREATEORDERSUCCESS,
        data: "",
      });
    } else {
      NotificationExtension.Fails(response?.message);
    }
  };

  const chooseWareHouse = async () => {
    setOpened2(true); // mở modal
    const response = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/CreateSellItem/get-list-inventory-onhand",
      {
        getListInventoryOnhands: listAdd.map((item) => ({
          itemId: item.itemId,
          itemCode: item.itemCode,
          quantity: item.quality,
        })),
        isFull: true,
        branchId: 0,
      },
    );

    if (response?.data) {
      setWarehouseList(response?.data);
    }
  };

  const handleChangeQuantity = (e: any, row: any) => {
    handleQuantityChange(e, row, branchId, location, setListAdd);
  };

  // Hàm mở modal theo loại
  const handleOpenModal = (type: string) => {
    setModalType(type);
  };

  // Hàm đóng modal
  const handleCloseModal = () => {
    setModalType("");
  };

  // Hàm xử lý lưu thông tin trả góp
  const handleSaveInstallment = () => {
    handleCloseModal();
  };

  // Hàm xử lý lưu thông tin công nợ
  const handleSaveDebt = () => {
    handleCloseModal();
  };

  const debouncedNoteChange = useDebouncedCallback(
    (value) =>
      setOrderHeader((prev) => ({
        ...prev,
        note: value,
      })),
    300,
  );

  const debouncedCashierNoteChange = useDebouncedCallback(
    (value) =>
      setOrderHeader((prev) => ({
        ...prev,
        attribute23: value,
      })),
    300,
  );

  const handleChangePrice = (value: any, key: string) => {
    handlePaymentChange(key, value, {
      setCashPayment,
      setBankTransfer,
      setCardPayment,
      setVnpayPayment,
      setAnotherPayment,
    });
  };

  const handleChooseCustomer = (value: any, isChooseCustomer: any) => {
    if (isChooseCustomer) {
      // Chỉ cập nhật attribute1 nếu isChooseCustomer = true
      setCustomerCheck({
        ...customerCheck,
        debtLimit: value?.debtLimit,
        debtTerm: value?.debtTerm,
        attribute1: value?.attribute1,
      });
      setOrderHeader({ ...orderHeader, attribute16: value?.attribute1 });
    } else {
      // Cập nhật toàn bộ thông tin khách hàng
      setCustomerCheck({
        ...customerCheck,
        code: value?.code,
        name: value?.name,
        telephoneNumber: value?.telephoneNumber,
        id: value?.id,
        type: value?.type,
        province: value?.province,
        district: value?.district,
        commune: value?.commune,
        address: value?.address,
        attribute1: value?.attribute1,
        attribute4: value?.attribute4,
        companyName: value?.companyName,
        debtLimit: value?.debtLimit,
        debtTerm: value?.debtTerm,
        groupId: value?.groupId,
        taxCode: value?.taxCode,
        email: value?.email,
      });

      setOrderHeader({ ...orderHeader, custId: value?.id });

      // Kiểm tra nếu listBuyerName có phần tử hợp lệ thì cập nhật state
      if (
        Array.isArray(value?.listBuyerName) &&
        value.listBuyerName.length > 0
      ) {
        const filteredBuyerNames = value.listBuyerName
          .map((buyer: any) => {
            const parts = [];

            if (buyer.name) parts.push(buyer.name);
            if (buyer.telephoneNumber) parts.push(buyer.telephoneNumber);
            if (buyer.attribute1) parts.push(buyer.attribute1);

            return parts.length > 0 ? parts.join(" - ") : null;
          })
          .filter(Boolean); // Loại bỏ giá trị null, undefined, ""

        setListBuyerName(filteredBuyerNames);

        setListAddress(value?.listAddress || []); // Cập nhật listAddress nếu có
        setDataDeliveryInformation((prev: any) => ({
          ...prev,
          listAddress: value?.listAddress || [],
        }));
        setOrderHeader((prev) => ({
          ...prev,
          attribute36: "",
        }));
      } else {
        setListBuyerName([]); // Nếu không có dữ liệu hợp lệ, đặt về mảng rỗng
        setListAddress([]); // Nếu không có dữ liệu hợp lệ, đặt về mảng rỗng
        setDataDeliveryInformation((prev: any) => ({
          ...prev,
          listAddress: [],
        }));
        setOrderHeader((prev) => ({
          ...prev,
          attribute36: "",
        }));
      }
    }
  };

  // Hàm nhận vào payType và trả về payAmount
  const getPayAmountByPayType = (payType: string): number | undefined => {
    const payment = dataPayment?.find((p: any) => p.PayType === payType);
    return payment ? payment?.PayAmount : undefined;
  };

  const getCardBank = () => {
    const bankCard = dataPayment?.find((p: any) => p.PayType === "03");
    return bankCard ? bankCard?.Attribute1 : undefined;
  };

  const headerRef = React.useRef<HTMLDivElement>(null);

  const handleAllocateItems = async () => {
    try {
      const requestBody = {
        priceKm: orderHeader?.amountDiscountTotal || 0, //  Khuyến mãi tổng đơn, cập nhật giá trị nếu cần
        priceReduce: orderHeader?.discountAddedTotal || 0,
        idItems: listAdd.map((item: any) => ({
          price: item.priceFinal || 0,
          itemId: item.itemId || 0,
          quantity: item.quality || 0,
          itemCode: item.itemCode || "",
        })),
      };

      const response = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblItem/get-allcation-item`,
        requestBody,
      );

      if (response && response.success) {
        const data = response.data;
        // Tính tổng priceAllKM và priceAll từ data
        const totalPriceAllKM = data?.reduce(
          (sum: number, item: any) =>
            sum + (item.priceAllKM * item?.quantity || 0),
          0,
        );
        const totalPriceAll = data?.reduce(
          (sum: number, item: any) =>
            sum + (item.priceAll * item?.quantity || 0),
          0,
        );

        // Lấy giá trị từ orderHeader
        const expectedPriceAllKM = orderHeader?.amountDiscountTotal || 0;
        const expectedPriceAll = orderHeader?.discountAddedTotal || 0;

        // Kiểm tra điều kiện hợp lệ
        if (
          expectedPriceAllKM > 0 &&
          Math.abs(totalPriceAllKM - expectedPriceAllKM) >= 10
        ) {
          NotificationExtension.Fails(
            `Lỗi: Tổng priceAllKM (${totalPriceAllKM}) không khớp với amountDiscountTotal (${expectedPriceAllKM})`,
          );
          return;
        }

        if (
          expectedPriceAll > 0 &&
          Math.abs(totalPriceAll - expectedPriceAll) >= 10
        ) {
          NotificationExtension.Fails(
            `Lỗi: Tổng priceAll (${totalPriceAll}) không khớp với discountAddedTotal (${expectedPriceAll})`,
          );
          return;
        }

        // Xử lý logic khi API trả về thành công
        setDataAllocate(response?.data);
        setIsDisablePhanBo(true);
      } else {
        // Xử lý khi API trả về nhưng không thành công
      }
    } catch (error) {
      console.error("Error allocating items:", error);
    }
  };

  const handleSelectProduct = async (
    product: ProductModel,
    index: number,
    modeSearch?: string,
  ) => {
    try {
      if (branchId) {
        const callapiPromotion = await repositoryPos.post<
          MessageResponse<TblItemPromotionModel[]>
        >(`/api/v1/TblItem/item-promotion`, {
          id: product.id,
          price: product?.price || 0,
          branch: branchId,
          groupId: customerCheck?.groupId,
        });

        const discountRate = 0;

        const discountAmount = 0;

        let idPromote = 0;
        let idPromoteHT = 0;

        if (callapiPromotion?.data) {
          idPromote =
            callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]?.id || 0;
          idPromoteHT =
            callapiPromotion?.data[0]?.tblPromotionItemGift[0]?.id || 0;
        }
        const addData: dataOrderDetailTable = {
          attribute23: product?.wareHouseCode,
          attribute20: product?.warranty?.toString(),
          id: product?.id,
          itemCode: product?.productCode,
          itemName: product?.productName,
          primaryUomCode: product?.unit || "",
          orgId: product?.warehouseId || 0,
          warehouse: product?.warehouse || "",
          priceType: "Giá niêm yết",
          quality: product?.quantity || 1,
          discountRate: discountRate,
          discountAmount: discountAmount,
          discountAdded: 0,
          priceFinal: discountRate
            ? (product?.price || 0) * 1 * (1 - discountRate / 100)
            : (product?.price || 0) * 1 - (discountAmount || 0) || 0,
          vatRate: 0,
          vatAmount: 0,
          totalLineAmount: discountRate
            ? (product?.price || 0) * 1 * (1 - discountRate / 100)
            : (product?.price || 0) * 1 - (discountAmount || 0) || 0,
          note: product?.notes ?? "",
          lineTyle: modeSearch === "DV" ? "DV" : "HH",
          orderHeaderId: 0,
          deptId: 0,
          itemId: product?.id,
          linkToItemId: 0,
          uomCode: "",
          priceListId: 0,
          priceOnPriceList: product?.price || 0,
          idPromote: idPromote || 0,
          idPromoteList: "",
          linkToLineId: 0,
          printInvoiceCheck: 0,
          promotePostPaid: "",
          promoteClearCheck: 0,
          promoteClearDate: "",
          prometeClearPersionId: 0,
          prometeClearClientId: "",
          clientId: 0,
          workShiftId: 0,
          createBy: 0,
          createDate: "",
          lastUpdateBy: 0,
          lastUpdateDate: "",
          subInvId: product?.warehouseId || 0,
          listIdPromotion: [
            callapiPromotion?.data &&
            callapiPromotion.data.length > 0 &&
            typeof callapiPromotion.data[0].tblPromotion.id === "number"
              ? callapiPromotion.data[0].tblPromotion.id
              : null,
          ].filter((id): id is number => id !== null),
          listIdAddOn: [],
          listIdGift:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemGift &&
              callapiPromotion?.data[0]?.tblPromotionItemGift.map(
                (item) => item.idItemGift,
              )) ||
            [],
          promotionDiscountPercent:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
                ?.discountPercent) ||
            0,
          promotionDiscountAmount:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemPrimary[0]
                ?.discountAmount) ||
            0,
          promotionItemGift:
            (callapiPromotion?.data &&
              callapiPromotion?.data.length > 0 &&
              callapiPromotion?.data[0]?.tblPromotionItemGift.map((item) => ({
                itemCode: item?.itemForSellModel.productCode,
                itemName: item?.itemForSellModel.productName,
                primaryUomCode: item?.itemForSellModel.unit || "",
                quality: 1,
                warehouse: item?.itemForSellModel.warehouse,
              }))) ||
            [],
        };

        if (
          callapiPromotion?.data &&
          callapiPromotion?.data[0]?.tblPromotionItemGift?.length > 0
        ) {
          setListAdd((prevList) => {
            // Nếu index === -1, thêm addData vào đầu mảng
            if (index === -1) {
              return [addData, ...prevList]; // Thêm addData vào đầu, và dataItemGif vào cuối
            } else {
              // Nếu index khác -1, cập nhật phần tử tại vị trí index và thêm dataItemGif
              const newList = [...prevList];
              newList[index] = addData;
              return newList;
            }
          });
          return;
        }

        setListAdd((prevList) => {
          if (index === -1) {
            return [addData, ...prevList];
          } else {
            const newList = [...prevList];
            newList[index] = addData;
            return newList;
          }
        });

        setIsCreating(false);
        table.setEditingRow(null);
        setDataProducts([]);
      }
    } catch (error) {
      console.error("Error in handleSelectProduct:", error);
    }
  };

  const handleGetNameAccountantById = async (
    accountantId: number | undefined,
  ) => {
    try {
      if (accountantId && accountantId != 0) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmEmployee/detail-employee?id=${accountantId}`,
        );
        if (response && response.success) {
          setAccountantName(response?.data?.fullName);
        }
      }
    } catch (error) {
      console.error("Error fetching accountant name:", error);
      return ""; // Trả về chuỗi rỗng nếu có lỗi
    }
  };

  const handleSelectPromotionMain = (promotionMain: any) => {
    const updatedList = listAdd.map((item) => {
      // Kiểm tra nếu itemId trùng với idItemPrimary
      if (
        item?.itemId ===
        promotionMain?.tblPromotionItemPrimary[0]?.idItemPrimary
      ) {
        // Cập nhật logic xử lý ở đây, ví dụ thêm trường mới hoặc thay đổi giá trị
        return {
          ...item,
          discountAmount:
            promotionMain?.tblPromotionItemPrimary[0]?.discountAmount,
          discountRate:
            promotionMain?.tblPromotionItemPrimary[0]?.discountPercent,
          priceFinal: promotionMain?.tblPromotionItemPrimary[0]?.discountPercent
            ? item?.priceOnPriceList *
                1 *
                (1 -
                  promotionMain?.tblPromotionItemPrimary[0]?.discountPercent /
                    100) -
              (item?.discountAdded || 0)
            : item?.priceOnPriceList * 1 -
                (promotionMain?.tblPromotionItemPrimary[0]?.discountAmount ||
                  0) -
                (item?.discountAdded || 0) || 0,
        };
      }
      return item; // Trả về item không thay đổi nếu không khớp
    });
    setListAdd(updatedList);
  };

  const handleSelectProductAddOn = async (
    products: itemAddOnPromotionModel[],
    itemId: string,
  ) => {
    try {
      if (branchId) {
        const newAddDataList: dataOrderDetailTable[] = [];

        for (const product of products) {
          const callapi = await repositoryPos.post<
            MessageResponse<ItemDetailPriceModel>
          >(
            `/api/v1/TblPriceListDetail/detail-price?id=${product?.idItemAddOn}&BranchId=${branchId}`,
          );

          if (callapi?.success) {
            const addData: dataOrderDetailTable = {
              attribute23: product?.itemForSellModel?.wareHouseCode,
              id: product?.idItemAddOn || 0,
              itemCode: product?.itemForSellModel?.productCode || "",
              itemName: product?.itemForSellModel?.productName || "",
              primaryUomCode: product?.itemForSellModel?.unit || "",
              orgId: product?.itemForSellModel?.warehouseId || 0,
              warehouse: product?.itemForSellModel?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: 1,
              discountRate: product.discountPercent || 0,
              discountAmount: product.discountAmount || 0,
              discountAdded: 0,
              priceFinal: product.discountPercent
                ? callapi?.data?.listPrice -
                  (callapi?.data?.listPrice * product.discountPercent) / 100
                : callapi?.data?.listPrice - (product.discountAmount || 0),
              vatRate: callapi.data?.vatRate || 0,
              vatAmount: callapi.data?.vatAmount || 0,
              totalLineAmount: product.discountPercent
                ? callapi?.data?.listPrice -
                  (callapi?.data?.listPrice * product.discountPercent) / 100
                : callapi?.data?.listPrice - (product.discountAmount || 0),
              note: "",
              lineTyle: "HK",
              orderHeaderId: 0,
              deptId: 0,
              itemId: product?.idItemAddOn || 0,
              linkToItemId: Number(itemId),
              uomCode: "",
              priceListId: callapi.data?.idPriceLis || 0,
              priceOnPriceList: callapi.data?.listPrice || 0,
              idPromote: product?.id || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: product?.itemForSellModel?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
            };

            newAddDataList.push(addData);
          }
        }

        setListAdd((prevList) => [...prevList, ...newAddDataList]);
        table.setEditingRow(null);
      }
    } catch (error) {
      console.error("Error in handleSelectProductAddOn:", error);
    }
  };

  const handleSelectProductGift = async (
    products: itemGiftPromotionModel[],
    itemId: string,
  ) => {
    try {
      if (branchId) {
        const addDataList: dataOrderDetailTable[] = [];

        for (const product of products) {
          const callapi = await repositoryPos.post<
            MessageResponse<ItemDetailPriceModel>
          >(
            `/api/v1/TblPriceListDetail/detail-price?id=${product?.idItemGift}&BranchId=${branchId}`,
          );

          if (callapi?.success) {
            const addData: dataOrderDetailTable = {
              attribute23: product?.itemForSellModel?.wareHouseCode,
              id: product?.idItemGift || 0,
              itemCode: product?.itemForSellModel?.productCode || "",
              itemName: product?.itemForSellModel?.productName || "",
              primaryUomCode: product?.itemForSellModel?.unit || "",
              orgId: product?.itemForSellModel?.warehouseId || 0,
              warehouse: product?.itemForSellModel?.warehouse || "",
              priceType: "Giá niêm yết",
              quality: 1,
              discountRate: 100,
              discountAmount: 0,
              discountAdded: 0,
              priceFinal: 0,
              vatRate: callapi.data?.vatRate || 0,
              vatAmount: callapi.data?.vatAmount || 0,
              totalLineAmount: 0,
              note: "",
              lineTyle: "KM",
              orderHeaderId: 0,
              deptId: 0,
              itemId: product?.idItemGift || 0,
              linkToItemId: Number(itemId),
              uomCode: "",
              priceListId: callapi.data?.idPriceLis || 0,
              priceOnPriceList: callapi.data?.listPrice || 0,
              idPromote: product?.id || 0,
              idPromoteList: "",
              linkToLineId: 0,
              printInvoiceCheck: 0,
              promotePostPaid: "",
              promoteClearCheck: 0,
              promoteClearDate: "",
              prometeClearPersionId: 0,
              prometeClearClientId: "",
              clientId: 0,
              workShiftId: 0,
              createBy: 0,
              createDate: "",
              lastUpdateBy: 0,
              lastUpdateDate: "",
              subInvId: product?.itemForSellModel?.warehouseId || 0,
              listIdPromotion: [],
              listIdAddOn: [],
              listIdGift: [],
              promotionDiscountPercent: 0,
              promotionDiscountAmount: 0,
            };
            addDataList.push(addData);
          }
        }

        setListAdd((prevList) => [...prevList, ...addDataList]);
      }
    } catch (error) {
      console.error("Error in handleSelectProductGift:", error);
    }
  };

  const checkDebtLimit = (dueAmount: any, debtLimit: any, debtType: string) => {
    if (debtType !== "Công nợ") return true;
    const totalDebt = dueAmount || 0; // Tổng số tiền nợ
    const limit = debtLimit || 0; // Hạn mức công nợ

    if (totalDebt > limit) {
      NotificationExtension.Fails(
        `Đơn Hàng ${
          orderHeader?.orderNumber
        } vượt quá hạn mức công nợ: ${limit.toLocaleString(
          "vi-VN",
        )} VNĐ. Không thể thanh toán.`,
      );
      return false; // Trả về false nếu vượt hạn mức công nợ
    }

    return true; // Trả về true nếu trong hạn mức
  };

  const handleUpdateCareSoftCode = async (
    orderNumber: string,
    careSoftCode: string,
    assigneeId: string,
  ) => {
    const response = await repositoryPos.post<MessageResponse<any[]>>(
      "/api/v1/CreateSellItem/update-caresoft-code",
      {
        orderNumber: orderNumber,
        attribute40: careSoftCode.toString(),
        attribute50: assigneeId,
      },
    );
  };

  const checkIsHaveAssigneeId = (employeeHacom: string) => {
    const dataEmployee = [
      { employeeCareSoft: "115129794", employeeHacom: "12898" },
      { employeeCareSoft: "129364674", employeeHacom: "11095" },
      { employeeCareSoft: "123901749", employeeHacom: "2743" },
      { employeeCareSoft: "115124190", employeeHacom: "2773" },
      { employeeCareSoft: "115128466", employeeHacom: "11093" },
      { employeeCareSoft: "115129853", employeeHacom: "2695" },
      { employeeCareSoft: "129036953", employeeHacom: "2781" },
      { employeeCareSoft: "115129822", employeeHacom: "16639" },
      { employeeCareSoft: "115129751", employeeHacom: "2783" },
      { employeeCareSoft: "115129918", employeeHacom: "2395" },
      { employeeCareSoft: "132858104", employeeHacom: "2782" },
      { employeeCareSoft: "115129894", employeeHacom: "2744" },
      { employeeCareSoft: "123628478", employeeHacom: "2779" },
      { employeeCareSoft: "115128221", employeeHacom: "12895" },
      { employeeCareSoft: "115128195", employeeHacom: "2586" },
      { employeeCareSoft: "115129870", employeeHacom: "2704" },
      { employeeCareSoft: "123182843", employeeHacom: "11096" },
      { employeeCareSoft: "215906509", employeeHacom: "2708" },
      { employeeCareSoft: "133893041", employeeHacom: "2776" },
      { employeeCareSoft: "133381804", employeeHacom: "2777" },
      { employeeCareSoft: "116758189", employeeHacom: "2775" },
      { employeeCareSoft: "115125293", employeeHacom: "2702" },
      { employeeCareSoft: "115128258", employeeHacom: "2780" },
      { employeeCareSoft: "126702301", employeeHacom: "2532" },
      { employeeCareSoft: "227986543", employeeHacom: "2565" },
    ];

    const employee = dataEmployee.find(
      (emp) => emp.employeeHacom === employeeHacom,
    );
    return employee ? employee.employeeCareSoft : "";
  };

  const handleSendMessageOrderSuccsess = async () => {
    const assigneeId = checkIsHaveAssigneeId(orderHeader?.saleId?.toString());
    if (!assigneeId) return;
    const formattedDate = dataDeliveryInformation?.deliveryAppointmentTime
      ? `${dataDeliveryInformation.timeDeliveryTime}:00  ` +
        dataDeliveryInformation.deliveryAppointmentTime.toLocaleDateString(
          "vi-VN",
          {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
          },
        )
      : "";
    const customerData = JSON.parse(orderHeader?.attribute1 || "");

    const payLatter =
      location?.state?.actionType === "view"
        ? orderHeader?.amountRemaining
        : deferredPayment - orderHeader?.amountPaid;

    const now = new Date();

    const response = await repositoryMdm.post<any>(
      "/api/v1/CareSoft/create-deal",
      {
        deal: {
          phone: customerData?.telephoneNumber
            ? customerData?.telephoneNumber
            : customerCheck?.telephoneNumber,
          subject: "Hacom - OA",
          value:
            location?.state?.actionType === "view"
              ? orderHeader?.amountTotal
              : payableAmount - orderHeader?.amountPaid,
          estimated_closed_date: "2024/03/21 23:59:59",
          pipeline_id: 202,
          pipeline_stage_id: 1551,
          assignee_id: assigneeId, // ID người phụ trách tạo đơn
          custom_fields: [
            { id: "11363", value: orderHeader?.orderNumber }, // Số đơn hàng
            { id: "11561", value: customerCheck?.name }, // Tên KH trên POS
            { id: "11562", value: customerCheck?.email }, // Email KH trên POS
            { id: "11383", value: formattedDate }, // ngày nhận hàng dự kiến
            { id: "11364", value: payLatter > 0 ? "165936" : "165935" }, //Đã thanh toán: 165935 Chưa thanh toán: 165936 Cọc: 165937
            {
              id: "11362",
              value: now
                .toLocaleString("vi-VN", {
                  hour: "2-digit",
                  minute: "2-digit",
                  day: "2-digit",
                  month: "2-digit",
                  year: "2-digit",
                })
                .replace(",", " -"),
            }, // ngày tạo đơn
            { id: "11365", value: customerData?.customerAddress }, // Địa chỉ khách hàng
            // Trạng thái giao hàng
            // Đơn hàng bị Huỷ: 167208
            // Đơn hàng giao trễ: 167209
            // Đơn hàng đã xuất kho: 167210
            // Giao thành công: 167211
            // { id: "11398", value: "167210" },
            // { id: "11384", value: moment().format("DD/MM/YY") }, // Thời điểm xuất kho - Text
            // { id: "11385", value: "Tai xe Vinh giao hang" }, //Thông tin nhân viên giao - text
            // { id: "11386", value: "120000" }, // Số tiền thanh toán còn lại
          ],
        },
        token: "1FRvLEuRQgf5gdE",
        careSoftId: "",
      },
    );
    let result = response?.deal?.id;

    handleUpdateCareSoftCode(
      orderHeader?.orderNumber,
      response?.deal?.id,
      assigneeId,
    );
  };

  const handleCallApiPayment = async () => {
    try {
      const customerData = JSON.parse(orderHeader?.attribute1 || "");
      if (customerData?.shippingVendor === "Ahamove") {
        const amountToCheck =
          location?.state?.actionType === "view"
            ? orderHeader?.amountRemaining
            : deferredPayment - orderHeader?.amountPaid;

        const typeShip = customerData?.typeShip;

        let limit = Infinity;

        if (typeShip === "Hỏa tốc") {
          limit = 10_000_000;
        } else if (typeShip === "2H") {
          limit = 1_000_000;
        }

        if (amountToCheck > limit) {
          const limitFormatted = limit.toLocaleString("vi-VN") + " VNĐ";
          NotificationExtension.Fails(
            `Số tiền cần thanh toán vượt quá giới hạn cho loại giao hàng "${typeShip}": ${limitFormatted}`,
          );
          return;
        }
      }

      const expectedPriceAllKM = orderHeader?.amountDiscountTotal || 0;
      const expectedPriceAll = orderHeader?.discountAddedTotal || 0;
      if (
        (expectedPriceAllKM > 0 || expectedPriceAll > 0) &&
        dataAllocate.length === 0
      ) {
        NotificationExtension.Fails("Vui lòng phân bổ trước khi thanh toán !");
        return;
      }
      //ghi log
      saveLogToLocalStorage();
      // Kiểm tra công nợ trước khi thực hiện thanh toán
      if (
        !checkDebtLimit(
          containsDT(orderHeader?.orderNumber) &&
            location?.state?.actionType !== "doi"
            ? orderHeader?.amountTotal
            : deferredPayment - orderHeader?.amountPaid,
          customerCheck?.debtLimit,
          dataPaymentLatter
            ? dataPaymentLatter?.payLaterMethod
            : payLaterMethod,
        )
      ) {
        return; // Dừng nếu công nợ vượt hạn mức
      }

      // Tạo mảng paymentCommands
      const paymentCommands = [
        {
          // Tiền mặt
          payType: "02",
          payAmount: cashPayment,
          payeeId: customerCheck?.id,
        },
        {
          // QR
          payType: "01",
          payAmount: bankTransfer,
          payeeId: customerCheck?.id,
          attribute1: selectedBankReserve,
          attribute2: transactionCodeReserve
            ? transactionCodeReserve
            : transactionCodeMb,
        },
        {
          // VN pay
          payType: "04",
          payAmount: vnpayPayment,
          payeeId: customerCheck?.id,
        },
        {
          // Cà thẻ
          payType: "03",
          payAmount: cardPayment,
          payeeId: customerCheck?.id,
          attribute1: mapSelectedBank(selectedBank), // Ngân hàng cà thẻ
        },
        {
          // Thanh toán khác
          payType: "08",
          payAmount: anotherPayment,
          payeeId: customerCheck?.id,
          attribute1: selectedBankReserve,
          attribute2: transactionCodeReserve,
        },
      ].filter((payment) => payment.payAmount > 0); // Lọc các phương thức thanh toán có payAmount > 0

      const combinedInfo = {
        payLaterMethod,
        installmentInfo:
          payLaterMethod === "Trả góp" ? installmentInfo : undefined,
        debtInfo: payLaterMethod === "Công nợ" ? debtInfo : undefined,
      };

      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/payment", {
        paymentCommands: paymentCommands,
        orderNumber: orderHeader?.orderNumber,
        attribute20: JSON.stringify(combinedInfo),
        attribute1: selectedBankReserve,
        attribute2: transactionCodeReserve,
        attribute23: orderHeader?.attribute23 || "",
        tblOrderDetails: dataAllocate?.length > 0 ? listAdd : [],
        orderTotal: payableAmount,
      });

      if (response?.success) {
        setOrderStatus("DON_HANG_HOAN_THANH");
        // Thanh toán thành công update thời gian hoàn thành
        setOrderHeader((prev) => ({
          ...prev,
          orderDate: new Date().toISOString(),
        }));

        setTimeout(
          () => NotificationExtension.Success("Hoàn tất thanh toán thành công"),
          500,
        );

        // setIsPrinting(true);
        // setIdPrint(location?.state.id);
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    }
    modals.closeAll();
  };

  const handleDeleteOrder = async (orderNumber: string, type: string) => {
    const res = await repositoryPos.get<MessageResponse<boolean>>(
      `/api/v1/CreateSellItem/delete?orderNumber=${orderNumber}`,
    );
    if (res?.success) {
      type === "cancel"
        ? NotificationExtension.Success("Hủy thành công !")
        : NotificationExtension.Success("Từ chối duyệt thành công !");
      setOrderStatus("DON_HANG_HUY");
    } else
      type === "cancel"
        ? NotificationExtension.Fails("Hủy thất bại !")
        : NotificationExtension.Fails("Từ chối duyệt thất bại !");
    modals.closeAll();
  };

  const handleCopyItemCodes = () => {
    const itemCodes = listAdd.map((item) => item.itemCode).join("\n"); // Ghép itemCode thành chuỗi
    navigator.clipboard
      .writeText(itemCodes)
      .then(() => {
        NotificationExtension.Success("Đã sao chép mã đơn hàng!");
      })
      .catch((err) => console.error("Lỗi sao chép:", err));
  };

  const handleClickCancelSalesOrder = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xác nhận hủy đơn hàng !</Title>
        </>
      ),

      size: "xs",
      children: (
        <Flex justify={"end"} gap={20} mt={"sm"}>
          <Button
            color="gray"
            leftSection={<IconWindow size={18} />}
            onClick={() => {
              modals.closeAll();
            }}
          >
            Huỷ
          </Button>
          <Button
            leftSection={<IconCheck size={18} />}
            onClick={() => {
              handleDeleteOrder(orderHeader?.orderNumber, "cancel");
              navigate("/sell/sales-order-list");
              modals.closeAll();
            }}
          >
            Xác nhận
          </Button>
        </Flex>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleCreateSalesOrder = useDebouncedCallback(
    async (isLock: boolean) => {
      if (isLock && orderHeader?.attribute39) {
        const isCheckTrue = await handleBuyItemByVoucher(
          customerCheck?.id,
          customerCheck?.name || customerCheck?.companyName || "",
          customerCheck?.telephoneNumber || "",
          orderHeader?.orderNumber,
          orderHeader?.attribute39 || "",
        );
        console.log("isCheckTrue", isCheckTrue);
        if (!isCheckTrue) {
          return;
        }
      }
      if (
        !handleCheckIsSuccessValidateItem(listAdd) &&
        location?.state?.actionType === "doi"
      ) {
        NotificationExtension.Warn(
          "Vui lòng điền trường hợp đổi , Serial đổi !",
        );
        return;
      }
      const isShippingRequired = shipping !== "Nhận tại cửa hàng";
      const isMissingDeliveryInfo = [
        dataDeliveryInformation?.customerId,
        dataDeliveryInformation?.telephoneNumber,
        dataDeliveryInformation?.customerProvinceId,
        dataDeliveryInformation?.customerDistrictId,
        dataDeliveryInformation?.customerCommuneId,
        dataDeliveryInformation?.customerAddress,
        dataDeliveryInformation?.deliveryAppointmentTime,
        dataDeliveryInformation?.shippingVendor,
        dataDeliveryInformation?.typeShip,
      ].some((field) => !field);

      if (isShippingRequired && isMissingDeliveryInfo) {
        NotificationExtension.Warn("Vui lòng điền đầy đủ thông tin giao hàng!");
        return;
      }

      if (!orderHeader?.custId && !orderHeaderRef?.custId) {
        NotificationExtension.Warn("Chưa có thông tin khách hàng!");
        return;
      }

      // Validate thông tin xuất hóa đơn VAT khi Có xuất VAT
      if (orderHeader?.printInvoiceCheck === 1) {
        if (
          !taxInfo.TaxCode ||
          !taxInfo.TaxCompany ||
          !taxInfo.TaxEmail ||
          !taxInfo.TaxAddress
        ) {
          NotificationExtension.Warn(
            "Vui lòng nhập đầy đủ thông tin xuất hóa đơn VAT: Mã số thuế, Tên công ty, Email nhận hóa đơn và Địa chỉ công ty",
          );
          return;
        }
      }

      let newListAdd: dataOrderDetailTable[];
      if (location?.state?.actionType === "doi") {
        newListAdd = listAdd
          .map((item) => {
            return {
              ...item,
              totalLineAmount: item.priceFinal * item.quality,
            };
          })
          .filter((i) => {
            return (
              i?.attribute11 !== "G" &&
              i?.attribute11 !== "H" &&
              i?.attribute11 !== "T"
            );
          });
      } else {
        newListAdd = listAdd.map((item) => {
          return {
            ...item,
            totalLineAmount: item.priceFinal * item.quality,
            deptId: orderHeader?.deptId,
          };
        });
      }

      openLoading();
      const response = await repositoryPos.post<
        MessageResponse<dataCreateSalesOrder>
      >("/api/v1/CreateSellItem/create", {
        orderDetail: newListAdd,
        orderHeader: {
          ...orderHeader,
          shipngType: shipping,
          shipingVendor: shipingVendor,
          invOrgId: branchId ? branchId : 488,
          orgId: branchId ? branchId : 488,
          saleChanelId: saleChanelId ? saleChanelId : 67,
          saleId: employeeSalesId,
          deptId: departmentId,
          printInvoiceCheck: orderHeader?.printInvoiceCheck,
          attribute2: accountantId,
          attribute18: employeeSalesRevenueId,
          contractcode: contractcode,
          orderTypeId: 2,
          branchId: branchId ? branchId : 488,
          amountTotal: payableAmount,
          amountDiscount: totalKMLine,
          amountVat: 0,
          attribute1: JSON.stringify({
            ...dataDeliveryInformation,
            branchId: branchId,
          }),
          createDate: orderHeader?.orderDate,
          orderNumberLink: location?.state?.orderNumberOld,
          attribute8:
            customerCheck?.name && customerCheck?.code
              ? `${customerCheck.name}||${customerCheck.code}`
              : "",
          attribute16: orderHeader?.attribute16
            ? orderHeader?.attribute16
            : customerCheck?.attribute1,
          attribute31: customerCheck?.attribute4,
          custId: orderHeader?.custId ? orderHeader?.custId : customerCheck?.id,
        },
        isRetun: location?.state?.actionType === "doi",
        isLock: isLock,
      });

      if (response && response.success) {
        setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");

        setTimeout(
          () =>
            NotificationExtension.Success(
              isLock
                ? "Chốt đơn hàng thành công !"
                : "Lưu đơn hàng thành công !",
            ),
          500,
        );

        SocketExtension.SendMessageToTopic<any>({
          topic: CREATEORDERSUCCESS,
          data: "",
        });
      } else {
        NotificationExtension.Fails(
          response?.message ||
            (isLock ? "Chốt đơn hàng thất bại !" : "Lưu đơn hàng thất bại !")
        );
      }
      closeLoading();
    },
    1000,
  );

  const handleExportExcel = () => {
    try {
      // map lại key để đổi tên cột
      const exportData = listAdd.map((item) => ({
        "Tên sản phẩm": item.itemName,
        "Mã sản phẩm": item.itemCode,
        "Mã kho": item.attribute23,
        "Đơn vị tính": item.primaryUomCode,
        "Số lượng": item.quality,
        "Giá bán lẻ": item.priceOnPriceList,
        "Khuyến mãi": item.discountAmount,
        "Xin giảm": item?.discountAdded,
        "Thành tiền": item.priceFinal * item.quality,
        "Bảo hành": item.attribute20,
        "Km phân bổ": item.attribute28,
        "Xin giảm phân bổ": item.attribute29,
        "Thành tiền sau bổ": item.attribute35,
        "Ghi chú": item.note,
        // thêm các cột khác nếu cần
      }));

      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
      xlsx.writeFile(workbook, "danh-sach-san-pham.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  // Function để validate giá TMDT trước khi chốt đơn
  const validateTMDTPrices = async (): Promise<boolean> => {
    try {
      // Lấy danh sách mã sản phẩm từ listAdd
      const itemCodes = listAdd
        .map((item) => item.itemCode)
        .filter((code) => code);

      if (itemCodes.length === 0) {
        NotificationExtension.Warn("Không có sản phẩm để kiểm tra giá!");
        return false;
      }

      // Call API để lấy giá TMDT
      const response = await repositoryPos.post<any>(
        "/api/v1/TblPriceList/get-prices-by-codes",
        itemCodes,
      );

      console.log("API Response:", response); // Debug log

      // Kiểm tra response và lấy data
      let apiPrices: any[] = [];
      if (response) {
        if (Array.isArray(response)) {
          apiPrices = response;
        } else if (response.data && Array.isArray(response.data)) {
          apiPrices = response.data;
        } else if (
          response.success &&
          response.data &&
          Array.isArray(response.data)
        ) {
          apiPrices = response.data;
        } else {
          console.error("Invalid response format:", response);
          NotificationExtension.Fails(
            "Định dạng dữ liệu giá TMDT không hợp lệ!",
          );
          return false;
        }
      } else {
        NotificationExtension.Fails(
          "Không thể lấy thông tin giá TMDT. Vui lòng thử lại!",
        );
        return false;
      }

      if (apiPrices.length === 0) {
        NotificationExtension.Warn("Không tìm thấy giá cho các sản phẩm!");
        return false;
      }

      const priceDiscrepancies: string[] = [];

      // So sánh giá từ API với giá trong listAdd
      listAdd.forEach((item) => {
        const apiPrice = apiPrices.find(
          (price: any) => price.itemCode === item.itemCode,
        );

        if (apiPrice) {
          // So sánh với trường ecommercePrice từ API
          const apiEcommercePrice = apiPrice.ecommercePrice || 0;
          const currentPrice = item.priceOnPriceList || 0;

          // Kiểm tra nếu giá không trùng nhau
          if (apiEcommercePrice !== currentPrice) {
            priceDiscrepancies.push(
              `${item.itemName} (${item.itemCode}): Giá hiện tại ${currentPrice.toLocaleString()}đ, Giá TMDT ${apiEcommercePrice.toLocaleString()}đ`,
            );
          }
        } else {
          // Không tìm thấy giá trong API
          priceDiscrepancies.push(
            `${item.itemName} (${item.itemCode}): Không tìm thấy giá TMDT`,
          );
        }
      });

      // Nếu có sự khác biệt về giá
      if (priceDiscrepancies.length > 0) {
        // Hiển thị modal thông báo lỗi với promise để chờ user action
        return new Promise<boolean>((resolve) => {
          modals.openConfirmModal({
            title: (
              <Text fw={600} c="red">
                ⚠️ Cảnh báo: Giá sản phẩm không khớp
              </Text>
            ),
            children: (
              <Box>
                <Text mb="md">
                  Phát hiện sự khác biệt giá giữa đơn hàng hiện tại và giá TMDT:
                </Text>

                {/* Bảng so sánh giá */}
                <Box
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    backgroundColor: "#f8f9fa",
                    padding: "12px",
                    borderRadius: "4px",
                    border: "1px solid #dee2e6",
                    marginBottom: "16px",
                  }}
                >
                  <Table striped highlightOnHover>
                    <Table.Thead>
                      <Table.Tr>
                        <Table.Th style={{ minWidth: "200px" }}>
                          Sản phẩm
                        </Table.Th>
                        <Table.Th
                          style={{ textAlign: "right", minWidth: "120px" }}
                        >
                          Giá hiện tại
                        </Table.Th>
                        <Table.Th
                          style={{ textAlign: "right", minWidth: "120px" }}
                        >
                          Giá TMDT
                        </Table.Th>
                        <Table.Th
                          style={{ textAlign: "right", minWidth: "120px" }}
                        >
                          Chênh lệch
                        </Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {listAdd.map((item, index) => {
                        const apiPrice = apiPrices.find(
                          (price: any) => price.itemCode === item.itemCode,
                        );
                        const currentPrice = item.priceOnPriceList || 0;
                        const ecommercePrice = apiPrice?.ecommercePrice || 0;
                        const difference = currentPrice - ecommercePrice;
                        const hasDiscrepancy = apiPrice
                          ? ecommercePrice !== currentPrice
                          : true;

                        if (!hasDiscrepancy) return null;

                        return (
                          <Table.Tr
                            key={index}
                            style={{
                              backgroundColor: hasDiscrepancy
                                ? "#fff3cd"
                                : "transparent",
                            }}
                          >
                            <Table.Td>
                              <Box>
                                <Text
                                  size="sm"
                                  fw={500}
                                  truncate
                                  style={{ maxWidth: "180px" }}
                                >
                                  {item.itemName}
                                </Text>
                                <Text size="xs" c="dimmed">
                                  {item.itemCode}
                                </Text>
                              </Box>
                            </Table.Td>
                            <Table.Td style={{ textAlign: "right" }}>
                              <Text size="sm" fw={500}>
                                {currentPrice.toLocaleString()}đ
                              </Text>
                            </Table.Td>
                            <Table.Td style={{ textAlign: "right" }}>
                              <Text
                                size="sm"
                                fw={500}
                                c={apiPrice ? "blue" : "red"}
                              >
                                {apiPrice
                                  ? `${ecommercePrice.toLocaleString()}đ`
                                  : "Không có"}
                              </Text>
                            </Table.Td>
                            <Table.Td style={{ textAlign: "right" }}>
                              {apiPrice ? (
                                <Text
                                  size="sm"
                                  fw={500}
                                  c={
                                    difference > 0
                                      ? "red"
                                      : difference < 0
                                        ? "green"
                                        : "gray"
                                  }
                                >
                                  {difference > 0 ? "+" : ""}
                                  {difference.toLocaleString()}đ
                                </Text>
                              ) : (
                                <Text size="sm" c="red">
                                  N/A
                                </Text>
                              )}
                            </Table.Td>
                          </Table.Tr>
                        );
                      })}
                    </Table.Tbody>
                  </Table>
                </Box>

                <Text size="sm" c="orange" style={{ textAlign: "center" }}>
                  Vui lòng cập nhật giá sản phẩm hoặc liên hệ quản lý để xác
                  nhận.
                </Text>
              </Box>
            ),
            labels: {
              confirm: "Chốt đơn (Chấp nhận sai giá)",
              cancel: "Hủy - Kiểm tra lại",
            },
            onConfirm: () => resolve(true), // Cho phép tiếp tục chốt đơn
            onCancel: () => resolve(false), // Dừng lại
            confirmProps: {
              color: "orange",
              leftSection: <IconCheck size={16} />,
            },
            cancelProps: {
              color: "gray",
            },
            size: "xl",
          });
        });
      }

      // Tất cả giá đều khớp
      return true;
    } catch (error) {
      console.error("Error validating TMDT prices:", error);
      NotificationExtension.Fails(
        "Lỗi khi kiểm tra giá TMDT. Vui lòng thử lại!",
      );
      return false;
    }
  };

  const handleEditSalesOrder = useDebouncedCallback(async (isLock: boolean) => {
    // Kiểm tra giá TMDT trước khi chốt đơn
    if (isLock) {
      const isPriceValid = await validateTMDTPrices();
      if (!isPriceValid) {
        return; // Dừng lại nếu giá không hợp lệ hoặc user chọn hủy
      }
    }
    if (isLock && orderHeader?.attribute39) {
      const isCheckTrue = await handleBuyItemByVoucher(
        customerCheck?.id,
        customerCheck?.name || customerCheck?.companyName || "",
        customerCheck?.telephoneNumber || "",
        orderHeader?.orderNumber,
        orderHeader?.attribute39 || "",
      );
      console.log("isCheckTrue", isCheckTrue);
      if (!isCheckTrue) {
        return;
      }
    }
    const isShippingRequired = shipping !== "Nhận tại cửa hàng";
    const isMissingDeliveryInfo = [
      dataDeliveryInformation?.customerId,
      dataDeliveryInformation?.telephoneNumber,
      dataDeliveryInformation?.customerProvinceId,
      dataDeliveryInformation?.customerDistrictId,
      dataDeliveryInformation?.customerCommuneId,
      dataDeliveryInformation?.customerAddress,
      dataDeliveryInformation?.deliveryAppointmentTime,
      dataDeliveryInformation?.shippingVendor,
      dataDeliveryInformation?.typeShip,
    ].some((field) => !field);

    if (isShippingRequired && isMissingDeliveryInfo) {
      NotificationExtension.Warn("Vui lòng điền đầy đủ thông tin giao hàng!");
      return;
    }

    if (!orderHeader.custId) {
      NotificationExtension.Warn("Chưa có thông tin khách hàng!");
      return;
    }

    const newListAdd = listAdd.map((item) => {
      return {
        ...item,
        totalLineAmount: item.priceFinal * item.quality,
        deptId: orderHeader?.deptId,
      };
    });
    openLoading();
    console.log("orderHeader", orderHeader);
    const response = await repositoryPos.post<
      MessageResponse<dataCreateSalesOrder>
    >("/api/v1/CreateSellItem/edit", {
      orderDetail: newListAdd,
      orderHeader: {
        ...orderHeader,
        shipngType: shipping,
        shipingVendor: shipingVendor,
        invOrgId: branchId ? branchId : 488,
        orgId: branchId ? branchId : 488,
        saleChanelId: saleChanelId
          ? saleChanelId
          : orderHeader?.saleChanelId
            ? orderHeader?.saleChanelId
            : 67,
        saleId: employeeSalesId,
        deptId: departmentId,
        printInvoiceCheck: orderHeader?.printInvoiceCheck,
        attribute2: accountantId, //Nguyễn Trang Quyên-0009
        attribute18: employeeSalesRevenueId,
        contractcode: contractcode,
        orderTypeId: 2,
        branchId: branchId ? branchId : 488,
        amountTotal: payableAmount,
        amountDiscount: totalKMLine,
        amountVat: 0,
        attribute1: JSON.stringify({
          ...dataDeliveryInformation,
          branchId: branchId,
        }),
        createDate: orderHeader?.orderDate,
        orderNumberLink: location?.state?.orderNumberOld,
        attribute8:
          customerCheck?.name && customerCheck?.code
            ? `${customerCheck.name}||${customerCheck.code}`
            : "",
        attribute16: orderHeader?.attribute16
          ? orderHeader?.attribute16
          : customerCheck?.attribute1,
        attribute31: customerCheck?.attribute4,
      },
      isLock: isLock,
    });

    if (response && response.success) {
      setOrderStatus(isLock ? "DON_HANG_CHOT" : "DON_HANG_TAM");

      const messageNoti = isLock
        ? "Chốt đơn hàng thành công !"
        : "Lưu đơn hàng thành công !";
      setTimeout(() => NotificationExtension.Success(messageNoti), 500);

      SocketExtension.SendMessageToTopic<any>({
        topic: CREATEORDERSUCCESS,
        data: "",
      });
      closeLoading();
      return true;
    } else {
      setTimeout(
        () =>
          NotificationExtension.Fails(
            response?.message ||
              (isLock ? "Chốt đơn hàng thất bại !" : "Lưu đơn hàng thất bại !")
          ),
        500,
      );
      closeLoading();
      return false;
    }
  }, 1000);

  //#region render ui
  const TableSelect: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mih={400} mah={600} minWidth={500} type="native">
        <div style={{ overflowY: "auto", height: "500px" }}>
          <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
            <Table.Thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10,
              }}
            >
              <Table.Tr>
                <Table.Th>Chọn</Table.Th>
                <Table.Th style={{ width: "70px" }}>Mã sản phẩm</Table.Th>
                <Table.Th style={{ width: "200px" }}>
                  Tên sản phẩm
                </Table.Th>{" "}
                {/* Đặt độ rộng cho cột "Tên sản phẩm" */}
                <Table.Th>Giá</Table.Th>
                <Table.Th>ĐVT</Table.Th>
                <Table.Th>Tồn kho</Table.Th>
                <Table.Th>SL chờ xuất</Table.Th>
                <Table.Th>SL khả dụng</Table.Th>
                <Table.Th>Bảo hành</Table.Th>
                <Table.Th>Mã kho</Table.Th>
                <Table.Th>Kho</Table.Th>
              </Table.Tr>
            </Table.Thead>

            {dataProducts?.length > 0 ? (
              <Table.Tbody>
                {dataProducts?.map((product: any, index: any) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Button
                        size="compact-sm"
                        variant="filled"
                        onClick={() => {
                          onSelectProduct(product, rowIndex);
                          table.setCreatingRow(null);
                        }}
                        disabled={
                          handleCheckChooseProduct(product, listAdd) ||
                          product.tons - product.tonao <= 0
                        }
                      >
                        {handleCheckChooseProduct(product, listAdd)
                          ? "Đã chọn"
                          : "Chọn"}
                      </Button>
                    </Table.Td>
                    <Table.Td>{product.productCode}</Table.Td>
                    <Table.Td style={{ width: "200px" }}>
                      {product.productName}
                    </Table.Td>{" "}
                    {/* Đặt độ rộng cho ô "Tên sản phẩm" */}
                    <Table.Td>
                      <NumberFormatter
                        value={product.price}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Table.Td>
                    <Table.Td>{product.unit}</Table.Td>
                    <Table.Td>{product.tons}</Table.Td>
                    <Table.Td>{product.tonao}</Table.Td>
                    <Table.Td>{product.tons - product.tonao}</Table.Td>
                    <Table.Td>{`${product.warranty} tháng`}</Table.Td>
                    <Table.Td>{product.wareHouseCode}</Table.Td>
                    <Table.Td>{product.warehouse}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            ) : (
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Text>Hãy nhập ID hoặc mã sản phẩm!</Text>
              </Box>
            )}
          </Table>
        </div>
      </Table.ScrollContainer>
    );
  };

  const TableSelectDV: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mih={400} mah={600} minWidth={500} type="native">
        <div style={{ overflowY: "auto", height: "500px" }}>
          {/* Table Header (Fixed) */}
          <Table striped withTableBorder style={{ tableLayout: "fixed" }}>
            <Table.Thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 10, // Đảm bảo tiêu đề luôn nằm trên cùng
              }}
            >
              <Table.Tr>
                <Table.Th>Chọn</Table.Th>
                <Table.Th>Mã sản phẩm</Table.Th>
                <Table.Th>Tên sản phẩm</Table.Th>
                <Table.Th>Giá</Table.Th>
                <Table.Th>ĐVT</Table.Th>
              </Table.Tr>
            </Table.Thead>
          </Table>

          {/* Table Body */}
          {dataProducts?.length > 0 ? (
            <Table striped withTableBorder>
              <Table.Tbody>
                {dataProducts?.map((product: any, index: any) => (
                  <Table.Tr key={index}>
                    <Table.Td>
                      <Button
                        size="xs"
                        variant="filled"
                        onClick={() => {
                          onSelectProduct(product, rowIndex);
                          table.setCreatingRow(null);
                        }}
                        disabled={handleCheckChooseProduct(product, listAdd)}
                      >
                        {handleCheckChooseProduct(product, listAdd)
                          ? "Đã chọn"
                          : "Chọn"}
                      </Button>
                    </Table.Td>
                    <Table.Td>{product.productCode}</Table.Td>
                    <Table.Td>{product.productName}</Table.Td>
                    <Table.Td>
                      <NumberFormatter
                        value={product.price}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Table.Td>
                    <Table.Td>{product.unit}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          ) : (
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Text>Hãy nhập ID hoặc mã sản phẩm!</Text>
            </Box>
          )}
        </div>
      </Table.ScrollContainer>
    );
  };

  const handleOnClickPrint = (id: any) => {
    setIsPrinting(true);
    setIdPrint(id);
  };

  // phần nhập voucher ////////////////////////////

  const [opened, setOpened] = useState(false);

  const [phone, setPhone] = useState("");
  const [voucher, setVoucher] = useState("");

  const closeVoucherModal = () => setOpened(false);
  const handleApplyVoucher = () => {
    console.log("Số điện thoại:", phone, "Mã voucher:", voucher);
    // Gọi API hoặc xử lý dữ liệu ở đây
    handleGetDataVoucher();
    handleCreateGetVoucher();
    closeVoucherModal();
  };

  const handleGetDataVoucher = async () => {
    const response = await repositoryMdm.get<MessageResponse<any>>(
      `api/v1/TblVourcher/get-list?skip=0&take=1000`,
    );

    if (response && response.success) {
      // Xử lý logic khi API trả về thành công
    } else {
      // Xử lý khi API trả về nhưng không thành công
    }
  };

  const handleBuyItemByVoucher = async (
    customerId: number,
    customerName: string,
    phoneNumber: string,
    orderCode: string,
    voucherCode: string,
    email?: string, // Email không bắt buộc
  ) => {
    if (
      !customerId ||
      !customerName ||
      !phoneNumber ||
      !orderCode ||
      !voucherCode
    ) {
      return false; // Kiểm tra nếu thiếu dữ liệu bắt buộc thì return false
    }

    const requestData: any = {
      customerId,
      customerName,
      phoneNumber,
      orderCode,
      vourcherCode: voucherCode,
      email: "",
      amountTotal:
        location?.state?.actionType === "view"
          ? orderHeader?.amountTotal
          : payableAmount - orderHeader?.amountPaid,
    };

    if (email) {
      requestData.email = email; // Chỉ thêm email nếu có
    }

    const response = await repositoryMdm.post<MessageResponse<any>>(
      `/api/v1/TblVoucherUsage/CompleteVoucher`,
      requestData,
    );

    return response ? true : false;
  };

  const handleCheckActiveVoucher = async (
    totalAmount: number | null | undefined,
    customerPhone: string | null | undefined,
    voucherCode: string | null | undefined,
  ) => {
    if ((totalAmount ?? 0) < 0 || !customerPhone || !voucherCode) {
      NotificationExtension.Fails(
        "Thiếu thông tin khách hàng , mã Voucher , tổng tiền",
      );
      return false;
    }

    const response = await repositoryMdm.post<MessageResponse<any>>(
      `/api/v1/TblVoucherUsage/checkRouterCondition`,
      {
        totalAmount,
        customerPhone,
        voucherCode,
      },
    );

    return response?.data;
  };

  const handleGetDetailDataVoucher = async (voucher: string) => {
    if (!voucher.trim()) {
      // Nếu voucher rỗng, đặt lại amountDiscountTotal = 0 và không gọi API
      setOrderHeader({
        ...orderHeader,
        amountDiscountTotal: 0,
      });
      return;
    }

    try {
      const check = await handleCheckActiveVoucher(
        location?.state?.actionType === "view"
          ? orderHeader?.amountTotal
          : payableAmount - orderHeader?.amountPaid,
        customerCheck?.telephoneNumber || "",
        voucher,
      );
      if (!check) {
        setOrderHeader({
          ...orderHeader,
          attribute39: "",
        });
        return;
      }
      const response = await repositoryMdm.get<MessageResponse<any>>(
        `api/v1/TblVoucherDetail/get-voucher-amount?voucherCode=${voucher}`,
      );

      if (response?.success) {
        console.log("response", response);
        setOrderHeader({
          ...orderHeader,
          amountDiscountTotal: response?.data || 0, // Đảm bảo giá trị hợp lệ
          amountVoucher: response?.data || 0,
        });
      } else {
        console.error("Lỗi API hoặc voucher không hợp lệ");
        setOrderHeader({
          ...orderHeader,
          amountDiscountTotal: 0, // Đặt lại giá trị nếu API không thành công
        });
      }
    } catch (error) {
      console.error("Lỗi khi gọi API voucher:", error);
      setOrderHeader({
        ...orderHeader,
        amountDiscountTotal: 0, // Đặt lại giá trị nếu có lỗi
      });
    }
  };

  const handleCreateGetVoucher = async () => {
    const response = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblVourcher/create`,
    );

    if (response && response.success) {
      // Xử lý logic khi API trả về thành công
    } else {
      // Xử lý khi API trả về nhưng không thành công
    }
  };

  const handleCreatePostVoucher = async () => {
    const response = await repositoryMdm.post<MessageResponse<any>>(
      `/api/v1/TblVourcher/create`,
      {
        voucherName: "quan tam zalo oa",
        // voucherType: "string",
        // issendmail: true,
        // issendsms: true,
        // issendzalo: true,
        // status: "string",
        expiredDate: "2025-12-27T07:18:06.927Z",
        // attribute1: "string",
        // attribute2: "string",
        // attribute3: "string",
        // attribute4: "string",
        // attribute5: "string",
        // attribute6: "string",
        // attribute7: "string",
        // attribute8: "string",
        // attribute9: "string",
        // attribute10: "string",
        // attribute11: "string",
        // attribute12: "string",
        // attribute13: "string",
        // attribute14: "string",
        // attribute15: "string",
        // createBy: 0,
        // createDate: "2025-03-27T07:18:06.927Z",
        // lastUpdateBy: 0,
        // lastUpdateDate: "2025-03-27T07:18:06.927Z",
        tblVourcherDetailslCommands: [
          {
            // id: 0,
            vourcherCode: "string",
            phoneNumber: "string",
            email: "string",
            customerName: "string",
            vourcherValue: "string",
            vourcherName: "string",
            expiredDate: "2025-03-27T07:18:06.927Z",
          },
        ],
      },
    );

    if (response && response.success) {
      // Xử lý logic khi API trả về thành công
      setDataAllocate(response?.data);
      setIsDisablePhanBo(true);
    } else {
      // Xử lý khi API trả về nhưng không thành công
    }
  };

  /////////////////////////////////////////////////
  // Customer edit functions
  const openEditCustomerModal = async () => {
    if (customerCheck) {
      // Debug customerCheck data
      console.log("DEBUG customerCheck:", customerCheck);
      console.log("DEBUG customerCheck keys:", Object.keys(customerCheck));
      console.log("DEBUG customerCheck.province:", customerCheck.province);
      console.log("DEBUG customerCheck.commune:", customerCheck.commune);

      // First, load provinces to ensure dropdown options are available
      await loadProvinces();

      // Get province and ward IDs from customer data
      const provinceId = customerCheck.province
        ? customerCheck.province.toString()
        : "";
      const wardId = customerCheck.commune
        ? customerCheck.commune.toString()
        : "";

      console.log("Customer data for modal:", {
        province: customerCheck.province,
        commune: customerCheck.commune,
        provinceId,
        wardId,
        fullCustomer: customerCheck,
      });

      // If customer has province, load wards for that province
      if (provinceId) {
        await loadWards(provinceId);
      }

      // Set customer data AFTER loading all dropdown options
      setEditCustomerData({
        name:
          customerCheck.type === 1
            ? customerCheck.name || ""
            : customerCheck.companyName || "",
        telephoneNumber: customerCheck.telephoneNumber || "",
        address: customerCheck.address || "",
        provinceId: customerCheck.province
          ? customerCheck.province.toString()
          : "",
        wardId: customerCheck.commune ? customerCheck.commune.toString() : "",
      });

      // Finally, open the modal
      setEditCustomerModalOpened(true);
    }
  };

  const loadProvinces = async () => {
    try {
      const response = await repositoryMdm.get(
        "/api/v1/TblDmProvinceMoi/get-list?Active=true&Skip=0&Take=500",
      );
      if (response?.data) {
        const provinces = response.data.map((item: any) => ({
          value: String(item.id),
          label: item.name,
        }));
        setDataProvinces(provinces);
      }
    } catch (error) {
      console.error("Error loading provinces:", error);
    }
  };

  const loadWards = async (provinceId: string) => {
    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${provinceId}`,
      );
      console.log("Wards API Response:", response); // Debug log
      if (response?.data) {
        const wards = response.data.map((item: any) => ({
          value: String(item.value), // Ensure value is string
          label: item.text,
        }));
        console.log("Mapped wards:", wards); // Debug log
        console.log("Customer commune ID:", customerCheck.commune); // Debug log
        setDataWards(wards);
      }
    } catch (error) {
      console.error("Error loading wards:", error);
    }
  };

  const handleSaveCustomerEdit = async () => {
    try {
      // Call API to update customer information using repositoryMdm
      const response = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/TblDmCustomer/update-limited",
        {
          id: customerCheck.id,
          name: editCustomerData.name,
          address: editCustomerData.address,
          telephoneNumber: editCustomerData.telephoneNumber,
          attribute13: editCustomerData.provinceId,
          attribute14: editCustomerData.wardId,
        },
      );

      if (response && response.success) {
        // Update local customer data after successful API call
        setCustomerCheck((prev) => ({
          ...prev,
          name: customerCheck?.type === 1 ? editCustomerData.name : prev?.name,
          companyName:
            customerCheck?.type !== 1
              ? editCustomerData.name
              : prev?.companyName,
          telephoneNumber: editCustomerData.telephoneNumber,
          address: editCustomerData.address,
          province: editCustomerData.provinceId
            ? parseInt(editCustomerData.provinceId)
            : prev?.province,
          commune: editCustomerData.wardId
            ? parseInt(editCustomerData.wardId)
            : prev?.commune,
        }));

        setEditCustomerModalOpened(false);
        NotificationExtension.Success(
          "Cập nhật thông tin khách hàng thành công!",
        );
      } else {
        NotificationExtension.Fails("Cập nhật thông tin khách hàng thất bại!");
      }
    } catch (error) {
      console.error("Error saving customer:", error);
      NotificationExtension.Fails(
        "Có lỗi xảy ra khi cập nhật thông tin khách hàng!",
      );
    }
  };

  // Auto load wards when province changes in edit modal
  React.useEffect(() => {
    if (editCustomerData.provinceId && editCustomerModalOpened) {
      loadWards(editCustomerData.provinceId);
      // Reset wardId when province changes
      setEditCustomerData((prev) => ({
        ...prev,
        wardId: "",
      }));
    } else {
      setDataWards([]);
    }
  }, [editCustomerData.provinceId, editCustomerModalOpened]);

  const titleSell = () => {
    return (
      <>
        <_breadcrumb></_breadcrumb>
        <Group align="center" p={"0 10 10 10"} justify="space-between">
          <Flex gap={"xs"}>
            <Button
              disabled={orderStatus === "noCreate"}
              color={"blue"}
              size="xs"
              style={{
                pointerEvents: "auto",
              }}
              onClick={() => {
                navigate("/sell/retail-order");
                window.location.reload();
              }}
            >
              Tạo mới
            </Button>
            <Tooltip
              label={isCollapse ? "Mở rộng" : "Thu gọn"}
              position="bottom"
            >
              <Group align="center">
                <Switch
                  size="sm"
                  color={isCollapse ? "red" : "green"}
                  checked={!isCollapse}
                  onChange={toggleCollapse}
                  label={isCollapse ? "Thu gọn (Ctrl+M)" : "Mở rộng (Ctrl+M)"}
                  thumbIcon={
                    !isCollapse ? (
                      <IconMaximize
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    ) : (
                      <IconMaximizeOff
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    )
                  }
                />
              </Group>
            </Tooltip>
          </Flex>
          <Flex
            gap="md"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <OrderStatus status={orderStatus || "noCreate"}></OrderStatus>
          </Flex>

          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            wrap="wrap"
            align="center"
            direction="row"
          >
            {orderStatus === "DON_HANG_HOAN_THANH" &&
            // !location?.state?.isReadOnly ? (
            true ? (
              <>
                <Button
                  leftSection={<IconPrinter size={20} />}
                  variant="outline"
                  color="indigo"
                  style={{
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  size="xs"
                  onClick={() => handleOnClickPrint(location?.state?.id)}
                  loading={isPrinting}
                >
                  In hóa đơn
                </Button>
              </>
            ) : (
              <></>
            )}
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT"
              }
              leftSection={<IconPlus size={14} />}
              variant="outline"
              color="blue"
              size="xs"
              onClick={() => {
                setModeSearch("SP");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Thêm sản phẩm
            </Button>
            <Button
              disabled={
                location?.state?.actionType === "view" ||
                location?.state?.actionType === "approved" ||
                location?.state?.actionType === "payment" ||
                orderStatus === "DON_HANG_CHOT"
              }
              leftSection={<IconPlus size={14} />}
              variant="outline"
              color="blue"
              size="xs"
              onClick={() => {
                setModeSearch("DV");
                setDataProducts([]);
                table.setCreatingRow(true);
                setIsCreating(true);
              }}
            >
              Thêm dịch vụ
            </Button>
            <Box
              style={{
                ...getStyle(),
              }}
            >
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <ActionIcon
                    style={{
                      pointerEvents: "auto",
                    }}
                    // disabled={
                    //   location?.state?.actionType === "view" ||
                    //   location?.state?.actionType === "approved" ||
                    //   location?.state?.actionType === "payment"
                    // }
                    size="md"
                    variant="outline"
                    color="blue"
                  >
                    <IconMenu2 style={{ width: rem(18), height: rem(18) }} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Label>Chức năng</Menu.Label>

                  <Menu.Item>
                    <Button
                      disabled={
                        orderStatus !== "DON_HANG_TAM" &&
                        orderStatus !== "DON_HANG_CHOT"
                      }
                      color={"red"}
                      size="xs"
                      onClick={() => handleClickCancelSalesOrder()}
                    >
                      Hủy đơn
                    </Button>
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      color={"blue"}
                      size="xs"
                      onClick={() => handleCopyItemCodes()}
                    >
                      copy mã hàng
                    </Button>
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      color={"green"}
                      size="xs"
                      onClick={() => handleExportExcel()}
                    >
                      Export excel
                    </Button>
                  </Menu.Item>
                  <Menu.Item>
                    <Button
                      color={"grape"}
                      size="xs"
                      onClick={() => chooseWareHouse()}
                      disabled={
                        !location.pathname.includes("revise-order") &&
                        !location.search.includes("revise-order")
                      }
                    >
                      Chọn kho sản phẩm
                    </Button>
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Flex>
        </Group>
      </>
    );
  };

  function getStyle(includePayment = false): CSSProperties {
    const isDisabled =
      location?.state?.actionType === "view" ||
      location?.state?.actionType === "approved" ||
      orderStatus === "DON_HANG_HOAN_THANH" ||
      (includePayment && location?.state?.actionType === "payment") ||
      (orderStatus === "DON_HANG_CHOT" &&
        location?.state?.actionType !== "payment") ||
      isHaveShiping;

    return {
      opacity: isDisabled ? 0.9 : 1,
      pointerEvents: isDisabled ? "none" : "auto",
    };
  }

  console.log("orderHeader?.attribute36", orderHeader?.attribute36);

  const formOrderHeader = () => {
    return (
      <Box
        style={{
          padding: 5,
          height: "100%",
          position: "relative",
          ...getStyle(),
        }}
      >
        <Box
          style={{
            ...getStyle(true),
          }}
        >
          <Grid>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Mã đơn hàng:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text fw={500}>{orderHeader?.orderNumber}</Text>
              </Flex>
              {(location?.state?.orderNumberOld ||
                orderHeader?.orderNumberLink) && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Mã ĐH cũ:<span style={{ color: "red" }}>*</span>
                  </Text>
                  <Text fw={500}>
                    {orderHeader?.orderNumberLink
                      ? orderHeader?.orderNumberLink
                      : location?.state?.orderNumberOld}
                  </Text>
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  readOnly
                  label="Chi nhánh:"
                  value={branchName}
                  options={handleGetNameBranch(listBranch) || []}
                  onChange={(value: any) => {
                    setBranchName(value);
                    const BranchId = listBranch.find((item) => {
                      return item.text == value;
                    });
                    setBranchId(Number(BranchId?.value));
                    setListAdd([]);
                    setDataProducts([]);
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="Bộ phận:"
                  value={department}
                  options={handleGetNameDepartment(listDepartment)}
                  onChange={(value) => {
                    setDepartment(value);
                    const departmentId = listDepartment?.find((item) => {
                      return item?.name === value;
                    });
                    setDepartmentId(departmentId?.departmentId);
                  }}
                  width="280px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  readOnly
                  required
                  label="NV tạo đơn:"
                  value={employeeSalesName}
                  options={[]}
                  onChange={(value: any) => {
                    alert("");
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="NV hưởng số:"
                  value={employeeSalesRevenueName}
                  options={handleGetNameEmployeeAll(listEmployeeSales) || []}
                  onChange={(value: any) => {
                    setEmployeeSalesRevenueName(value);
                    const saleRevenueId = listEmployeeSales.find((item) => {
                      return `${item?.fullname} - ${item?.code}` === value;
                    });
                    setEmployeeSalesRevenueId(saleRevenueId?.id);
                  }}
                  width="250px"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Mã ĐTCN:</Text>
                <Box style={{ position: "relative", maxWidth: "200px" }}>
                  <Tooltip
                    label={
                      orderHeader?.attribute16 || customerCheck?.attribute1
                    }
                    disabled={
                      !orderHeader?.attribute16 && !customerCheck?.attribute1
                    }
                  >
                    <Text fw={500} truncate>
                      {orderHeader?.attribute16 ||
                        customerCheck?.attribute1 ||
                        "Tìm mã ĐTCN"}
                    </Text>
                  </Tooltip>
                  <IconSearch
                    size={20}
                    style={{
                      position: "absolute",
                      right: -30,
                      top: 0,
                      cursor: "pointer",
                      color: cobalt_blue.base,
                    }}
                    onClick={() => openFormCustomer(true)}
                  />
                </Box>
              </Flex>
              <Box>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Khách hàng:<span style={{ color: "red" }}>*</span>
                  </Text>
                  <Box style={{ position: "relative", maxWidth: "200px" }}>
                    <Tooltip
                      label={customerCheck?.name}
                      disabled={!customerCheck?.name}
                    >
                      <Text fw={500} truncate>
                        {customerCheck?.type === 1
                          ? customerCheck?.name || "Tìm khách hàng"
                          : customerCheck?.companyName || "Tìm khách hàng"}
                      </Text>
                    </Tooltip>
                    <IconSearch
                      size={20}
                      style={{
                        position: "absolute",
                        right: -30,
                        top: 0,
                        cursor: "pointer",
                        color: cobalt_blue.base,
                      }}
                      onClick={() => openFormCustomer(false)}
                    />
                    {(customerCheck?.name || customerCheck?.companyName) && (
                      <IconEdit
                        size={20}
                        style={{
                          position: "absolute",
                          right: -60,
                          top: 0,
                          cursor: "pointer",
                          color: cobalt_blue.base,
                        }}
                        onClick={openEditCustomerModal}
                      />
                    )}
                  </Box>
                </Flex>

                {/* {orderHeader?.attribute61 &&
                  (() => {
                    try {
                      const buyerData = JSON.parse(orderHeader.attribute61);
                      const tooltipContent = [
                        buyerData.BuyerName && `Tên: ${buyerData.BuyerName}`,
                        buyerData.BuyerTelephone &&
                          `SĐT: ${buyerData.BuyerTelephone}`,
                        buyerData.BuyerEmail &&
                          `Email: ${buyerData.BuyerEmail}`,
                      ]
                        .filter(Boolean)
                        .join(" | ");
                      const allInfo = tooltipContent;
                      return (
                        <>
                          <Tooltip label={tooltipContent} multiline>
                            <Text
                              size="sm"
                              style={{
                                color: "#ffa500",
                                fontWeight: 500,
                                cursor: "pointer",
                                marginLeft: "100px",
                                display: "inline-block",
                              }}
                            >
                              ⚠️ Có người mua mới
                            </Text>
                          </Tooltip>
                          <Popover
                            opened={buyerPopoverOpened}
                            onChange={setBuyerPopoverOpened}
                            width={320}
                            position="bottom"
                            withArrow
                          >
                            <Popover.Target>
                              <Button
                                size="xs"
                                variant="light"
                                ml={8}
                                onClick={() => setBuyerPopoverOpened((o) => !o)}
                                style={{ verticalAlign: "middle" }}
                              >
                                Xem & Copy
                              </Button>
                            </Popover.Target>
                            <Popover.Dropdown>
                              <div style={{ marginBottom: 12 }}>
                                {buyerData.BuyerName && (
                                  <div style={{ marginBottom: 8 }}>
                                    <b>Tên:</b> {buyerData.BuyerName}
                                    <Button
                                      size="xs"
                                      ml={8}
                                      onClick={() =>
                                        handleCopyBuyer(buyerData.BuyerName)
                                      }
                                    >
                                      Copy
                                    </Button>
                                  </div>
                                )}
                                {buyerData.BuyerTelephone && (
                                  <div style={{ marginBottom: 8 }}>
                                    <b>SĐT:</b> {buyerData.BuyerTelephone}
                                    <Button
                                      size="xs"
                                      ml={8}
                                      onClick={() =>
                                        handleCopyBuyer(
                                          buyerData.BuyerTelephone
                                        )
                                      }
                                    >
                                      Copy
                                    </Button>
                                  </div>
                                )}
                                {buyerData.BuyerEmail && (
                                  <div style={{ marginBottom: 8 }}>
                                    <b>Email:</b> {buyerData.BuyerEmail}
                                    <Button
                                      size="xs"
                                      ml={8}
                                      onClick={() =>
                                        handleCopyBuyer(buyerData.BuyerEmail)
                                      }
                                    >
                                      Copy
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </Popover.Dropdown>
                          </Popover>
                        </>
                      );
                    } catch (error) {
                      console.error("Error parsing attribute61:", error);
                      return null;
                    }
                  })()} */}
              </Box>
              {(listBuyerName?.length > 0 || orderHeader?.attribute36) && (
                <Flex align="center" gap="xs">
                  <EditableTextWithOptions
                    required
                    label="Người MH:"
                    value={orderHeader?.attribute36 || ""}
                    options={listBuyerName}
                    onChange={(value: any) => {
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute36: value,
                      }));
                    }}
                    width="250px"
                  />
                </Flex>
              )}

              <Flex align="center" gap="xs">
                {!orderHeader?.attribute36 && (
                  <>
                    <Text style={{ flex: "0 0 100px" }}>
                      Số điện thoại:<span style={{ color: "red" }}>*</span>
                    </Text>
                    <Text style={{ flex: "0 0 100px", fontWeight: "500" }}>
                      {customerCheck?.telephoneNumber}
                    </Text>
                  </>
                )}
                <CustomerDetail
                  customerCheck={customerCheck}
                  attribute36={orderHeader?.attribute36}
                  orderType={2}
                ></CustomerDetail>
              </Flex>
            </Grid.Col>
            <Grid.Col span={6}>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Thời gian tạo:</Text>
                <Text fw={500}>
                  {formatDateString(orderHeader?.createDate)}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>Thời gian HT:</Text>
                <Text fw={500}>
                  {formatDateString(formatOrderDate(orderHeader?.orderDate))}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Kênh bán:"
                  value={saleChanel}
                  options={handlerRenderOptionSelect(saleChanelList)}
                  onChange={(value) => {
                    setSaleChanel(value);
                    const id = saleChanelList?.find((item) => {
                      return item.name === value;
                    });
                    setSaleChanelId(id.id);
                  }}
                  width="280px"
                />
              </Flex>
              {location?.state?.actionType === "payment" && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>Thu ngân:</Text>
                  <Text fw={500}>{userLogin?.fullname}</Text>
                </Flex>
              )}
              {location?.state?.actionType === "view" &&
                orderHeader?.orderStatus === "DON_HANG_HOAN_THANH" && (
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 100px" }}>Thu ngân:</Text>
                    <Text fw={500}>{accountantName}</Text>
                  </Flex>
                )}
              <Flex align="center" gap="xs">
                <Text style={{ flex: "0 0 100px" }}>
                  Loại KH:<span style={{ color: "red" }}>*</span>
                </Text>
                <Text fw={500}>
                  {customerCheck?.type
                    ? customerCheck?.type === 1
                      ? "Khách lẻ"
                      : "Khách doanh nghiệp"
                    : ""}
                </Text>
              </Flex>
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Thông tin HĐ:"
                  popoverLabel="Chọn thông tin HĐ:"
                  value={
                    (orderHeader?.printInvoiceCheck ?? 0) === 0
                      ? "Không"
                      : orderHeader?.printInvoiceCheck === 1
                        ? "Có"
                        : "Nợ"
                  }
                  options={["Không", "Có", "Nợ"]}
                  optionLabels={{
                    Không: "KH tiêu dùng – HĐ khách lẻ",
                    Có: "Có lấy hóa đơn",
                    Nợ: "Nợ hóa đơn",
                  }}
                  onChange={(e) => {
                    setOrderHeader((prev) => ({
                      ...prev,
                      printInvoiceCheck:
                        e === "Không"
                          ? 0
                          : e === "Có"
                            ? 1
                            : e === "Nợ"
                              ? 2
                              : prev.printInvoiceCheck,
                    }));
                  }}
                />
              </Flex>
              {/* Icon để mở modal thông tin VAT - style giống các trường khác */}
              {(orderHeader?.printInvoiceCheck === 1 ||
                orderHeader?.printInvoiceCheck === 2) && (
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 100px" }}>
                    Thông tin xuất hóa đơn VAT:
                  </Text>
                  <ActionIcon
                    color="blue"
                    variant="light"
                    onClick={() => setTaxInfoModalOpened(true)}
                    title={
                      location?.state?.actionType === "view"
                        ? "Xem thông tin xuất hóa đơn VAT"
                        : "Chỉnh sửa thông tin xuất hóa đơn VAT"
                    }
                    style={{ pointerEvents: "auto" }}
                  >
                    <IconEdit size={18} />
                  </ActionIcon>
                </Flex>
              )}
              <Flex align="center" gap="xs">
                <EditableTextWithOptions
                  required
                  label="Yêu cầu DV:"
                  value={handleGetTechnicialRequireName(
                    orderHeader?.technicalRequired ?? 0,
                  )}
                  options={[
                    "Không",
                    "Lắp ráp(mới)",
                    "Kiểm tra(mới)",
                    "Lắp ráp(mới) + Kiểm tra(mới)",
                  ]}
                  onChange={(e) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      technicalRequired: handleGetTechnicialRequireId(e) ?? 0,
                    }))
                  }
                />
              </Flex>
              <Flex>
                <SelectBuildPc
                  value={parseAttribute19(orderHeader?.attribute19)}
                  onChange={(data) => {
                    const updatedAttribute19 = JSON.stringify({
                      machineCode: data.machineCode,
                      quantity: data.quantity,
                    });
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute19: updatedAttribute19,
                    }));
                  }}
                  required
                  label="Build Pc"
                />
              </Flex>
              <Flex align="center" gap="xs">
                <SelectPaymentMethod
                  customerCheck={customerCheck}
                  required
                  width="230px"
                  label="PT thanh toán:"
                  value={orderHeader?.attribute24 || "Thu Tiền Ngay"}
                  shipping={shipping}
                  options={[
                    "Thu Tiền Ngay",
                    "Thu tiền sau lắp đặt",
                    "Giao Hàng Thu Tiền(COD)",
                    "Đã chuyển khoản",
                    "Trả góp",
                    "Đối Trừ Công Nợ",
                    "Công nợ nội bộ",
                    "Công Nợ 3 Ngày",
                    "Công Nợ 4 Ngày",
                    "Công Nợ 5 Ngày",
                    "Công Nợ 7 Ngày",
                    "Công Nợ 10 Ngày",
                    "Công Nợ 15 Ngày",
                    "Công Nợ 20 Ngày",
                    "Công Nợ 21 Ngày",
                    "Công Nợ 30 Ngày",
                  ]}
                  onChange={(e) =>
                    setOrderHeader((prev) => ({
                      ...prev,
                      attribute24: e ?? "",
                    }))
                  }
                />
              </Flex>
              <Flex align="center" gap="xs" mt={-4}>
                <Text style={{ flex: "0 0 100px" }}>Mã hợp đồng:</Text>
                <TextInput
                  value={contractcode}
                  onChange={(e) => setContractcode(e.target.value)}
                  variant="unstyled"
                  size="sm"
                  fs={"14px"}
                  fw={"500"}
                  placeholder="Nhập mã đợp đồng"
                />
              </Flex>
            </Grid.Col>
          </Grid>
          <Divider my="sm" mt={0} />
          <Grid mt={10}>
            <Grid.Col span={6}>
              <Flex
                align="center"
                gap="xs"
                style={isHaveShiping ? { pointerEvents: "auto" } : undefined}
              >
                <EditableTextWithOptions
                  required
                  label="Giao hàng:"
                  value={shipping}
                  options={["Nhận tại cửa hàng", "Giao hàng"]}
                  onChange={(val) => {
                    setShipping(val);
                    if (
                      val === "Nhận tại cửa hàng" &&
                      (orderHeader?.attribute24 === "Giao Hàng Thu Tiền(COD)" ||
                        orderHeader?.attribute24?.toLowerCase()?.includes("giao hàng thu tiền"))
                    ) {
                      setOrderHeader((prev) => ({
                        ...prev,
                        attribute24: "Thu Tiền Ngay",
                      }));
                      NotificationExtension.Warn(
                        "Đã tự động chuyển PT thanh toán về 'Thu Tiền Ngay' do nhận tại cửa hàng!",
                      );
                    }
                  }}
                />
              </Flex>
            </Grid.Col>
            <Grid.Col span={6}>
              <Grid>
                {shipping === "Nhận tại cửa hàng" && (
                  <Grid.Col span={12}>
                    <Flex align="center" gap="xs">
                      <Text style={{ flex: "0 0 100px" }}>
                        Địa chỉ lấy hàng:
                      </Text>
                      <Text fw={500}>
                        {orderHeader?.attribute62 || "Chưa có địa chỉ"}
                      </Text>
                    </Flex>
                  </Grid.Col>
                )}
                {(shipping === "Nội bộ" ||
                  shipping === "Đối tác vận chuyển" ||
                  shipping === "Giao hàng") && (
                  <Grid.Col span={6}>
                    <Flex>
                      <Text style={{ flex: "0 0 57px" }}>
                        Chi tiết: <span style={{ color: "red" }}>*</span>
                      </Text>
                      <Button
                        style={{
                          pointerEvents:
                            location?.state?.actionType === "payment" ||
                            location?.state?.actionType === "approved"
                              ? "none"
                              : "auto",
                        }}
                        ml={10}
                        size="xs"
                        onClick={() => {
                          if (listAdd.length > 0) {
                            if (shipingVendor || true) {
                              openModalDeliveryInformation();
                            } else {
                              NotificationExtension.Warn(
                                "Chưa chọn đơn vị tiếp nhận !",
                              );
                            }
                          } else {
                            NotificationExtension.Warn(
                              "Chưa có sản phẩm trong đơn !",
                            );
                          }
                        }}
                        variant="transparent"
                      >
                        <IconTruck size={22} /> {/* Biểu tượng xe tải */}
                      </Button>
                    </Flex>
                  </Grid.Col>
                )}
              </Grid>
            </Grid.Col>
          </Grid>
        </Box>
        <Divider my={"sm"} />
        {/* {!location?.state?.isReadOnly && ( */}
        {true && (
          <Box>
            <Grid>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng tiền hàng:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={displayTotalAmount}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Giảm giá:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={Math.abs(totalPromotionOrder)}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Sau giảm giá:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={amountAfterDiscount}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng phí sàn:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={
                        totalFloorFee === 0 ? 0 : `-${Math.abs(totalFloorFee)}`
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>
                    Phí sàn cập nhật sau:
                  </Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={
                        floorFeeAfter === 0 ? 0 : `-${Math.abs(floorFeeAfter)}`
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pt={0} pb={0}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>
                    Số tiền cần thanh toán:
                  </Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"} style={{ color: "red" }}>
                    <NumberFormatter
                      style={{ fontSize: "17px" }}
                      value={
                        location?.state?.actionType === "view"
                          ? orderHeader?.amountTotal
                          : payableAmount - orderHeader?.amountPaid
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                    {` (Đã VAT) `}
                  </Text>
                </Flex>
              </Grid.Col>
            </Grid>
            <Divider my={"sm"} />
            <Grid>
              <Grid.Col span={12} pt={0} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs" style={{ pointerEvents: "auto" }}>
                  <Text fs={"16px"} fw={"500"} style={{ flex: "0 0 150px" }}>
                    Thanh toán trước:
                  </Text>
                  {location?.state?.actionType === "view" &&
                    orderHeader?.orderStatus === "DON_HANG_HOAN_THANH" && (
                      <>
                        <Text fw={500} style={{ width: "25%" }}></Text>
                        <PaymentDetails
                          orderNumber={orderHeader?.orderNumber}
                        ></PaymentDetails>
                      </>
                    )}
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} mt={-12} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tiền mặt:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={location?.state?.actionType !== "payment"}
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32 }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("02")
                        : cashPayment || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "cashPayment")}
                    clampBehavior="strict"
                    min={1}
                    max={100000000000}
                    allowNegative={false}
                    allowDecimal={false}
                  />
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Chuyển khoản:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={location?.state?.actionType !== "payment"}
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32 }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("01")
                        : bankTransfer || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "bankTransfer")}
                    min={1}
                    max={10000000000}
                    clampBehavior="strict"
                    allowNegative={false}
                    allowDecimal={false}
                  />
                  {!(
                    location?.state?.actionType == "approved" ||
                    location?.state?.actionType !== "payment"
                  ) &&
                    bankTransfer && (
                      <IconCreditCard
                        style={{
                          cursor: "pointer",
                          color: cobalt_blue.base, // Adjust color if needed
                        }}
                        onClick={() =>
                          openModalPaymentMb(bankTransfer, anotherPayment)
                        }
                      />
                    )}
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>CK khác:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <NumberInput
                    disabled={location?.state?.actionType !== "payment"}
                    variant="unstyled"
                    autoFocus
                    style={{ height: 32 }}
                    size="md"
                    fw={"500"}
                    placeholder={"Nhập số tiền"}
                    hideControls
                    value={
                      dataPayment
                        ? getPayAmountByPayType("08")
                        : anotherPayment || ""
                    }
                    thousandSeparator="."
                    decimalSeparator=","
                    onChange={(e) => handleChangePrice(e, "anotherPayment")}
                    min={1}
                    max={10000000000}
                    clampBehavior="strict"
                    allowNegative={false}
                    allowDecimal={false}
                  />
                </Flex>
              </Grid.Col>

              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs" direction="column">
                  <Flex align="center" gap="xs" style={{ width: "100%" }}>
                    <Text style={{ flex: "0 0 150px" }}>Thanh toán thẻ:</Text>
                    <Text fw={500} style={{ width: "25%" }}></Text>
                    <NumberInput
                      disabled={location?.state?.actionType !== "payment"}
                      variant="unstyled"
                      autoFocus
                      style={{ height: 32 }}
                      size="md"
                      fw={"500"}
                      placeholder={"Nhập số tiền"}
                      hideControls
                      value={
                        dataPayment
                          ? getPayAmountByPayType("03")
                          : cardPayment || ""
                      }
                      thousandSeparator="."
                      decimalSeparator=","
                      onChange={(value) =>
                        handleChangePrice(value, "cardPayment")
                      }
                      min={1}
                      max={10000000000}
                      clampBehavior="strict"
                      allowNegative={false}
                      allowDecimal={false}
                    />
                    {(dataPayment
                      ? getPayAmountByPayType("03")
                      : false || cardPayment != 0) && (
                      <Select
                        placeholder="Chọn ngân hàng"
                        data={bankOptions}
                        value={dataPayment ? getCardBank() : selectedBank || ""}
                        onChange={(e) => setSelectedBank(e || "")}
                        style={{ width: "25%" }}
                        disabled={location?.state?.actionType !== "payment"}
                      />
                    )}
                  </Flex>
                </Flex>
              </Grid.Col>
              <Grid.Col span={12} pb={0} h={"fit-content"}>
                <Flex align="center" gap="xs">
                  <Text style={{ flex: "0 0 150px" }}>Tổng:</Text>
                  <Text fw={500} style={{ width: "25%" }}></Text>
                  <Text fw={"500"}>
                    <NumberFormatter
                      value={totalPaid || 0}
                      thousandSeparator="."
                      decimalSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
              <>
                <Grid.Col span={12} py={0} h={"fit-content"}>
                  <Flex align="center" gap="xs">
                    <Text style={{ flex: "0 0 150px", fontWeight: "500" }}>
                      Thanh toán sau:
                    </Text>
                    <Box
                      style={{
                        width: "25%",
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      {/* <EditableTextWithOptions
                          isCod
                          label=""
                          value={
                            dataPaymentLatter
                              ? dataPaymentLatter?.payLaterMethod
                              : payLaterMethod
                          }
                          options={["Không", "COD", "Công nợ", "Trả góp"]}
                          onChange={setPayLaterMethod}
                        /> */}
                    </Box>
                    <Text fw={"500"} style={{ color: "red" }}>
                      <NumberFormatter
                        style={{ fontSize: "17px" }}
                        value={
                          location?.state?.actionType === "view"
                            ? orderHeader?.amountRemaining
                            : deferredPayment - orderHeader?.amountPaid
                        }
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </Text>
                    {/* Nút bấm hiển thị modal nếu điều kiện phù hợp */}
                    {/* {payLaterMethod === "Công nợ" && (
                        <Button
                          size="xs"
                          onClick={() => handleOpenModal("Công nợ")}
                          style={{
                            marginLeft: "10px",
                            pointerEvents:
                              location?.state?.actionType === "view" ||
                              location?.state?.actionType === "payment"
                                ? "auto"
                                : "none",
                          }}
                        >
                          Nhập công nợ
                        </Button>
                      )} */}
                    {payLaterMethod === "Trả góp" && (
                      <Button
                        size="xs"
                        onClick={() => handleOpenModal("Trả góp")}
                        style={{
                          marginLeft: "10px",
                          pointerEvents:
                            location?.state?.actionType === "view" ||
                            location?.state?.actionType === "payment"
                              ? "auto"
                              : "none",
                        }}
                      >
                        Nhập trả góp
                      </Button>
                    )}
                  </Flex>
                </Grid.Col>

                {/* Modal Công nợ */}
                <Modal
                  style={{
                    pointerEvents:
                      location?.state?.actionType === "payment" &&
                      orderStatus !== "DON_HANG_HOAN_THANH"
                        ? "auto"
                        : "none",
                  }}
                  opened={modalType === "Công nợ"}
                  onClose={handleCloseModal}
                  title="Nhập thông tin Công nợ"
                  centered
                >
                  {/* Hiển thị thông báo thời hạn công nợ mặc định */}
                  <Text size="sm" color="dimmed" mb="sm" mt={10}>
                    Thời hạn công nợ là{" "}
                    <strong>{customerCheck?.debtTerm || 0}</strong> ngày. Tối đa
                    có thể nhập là{" "}
                    <strong>{(customerCheck?.debtTerm || 0) * 2}</strong> ngày.
                  </Text>

                  {/* Hiển thị hạn mức công nợ với dấu chấm ngăn cách */}
                  <Text size="sm" color="dimmed" mb="sm">
                    Hạn mức công nợ:
                    <strong>
                      {(customerCheck?.debtLimit || 0).toLocaleString("vi-VN")}{" "}
                      VNĐ
                    </strong>
                  </Text>

                  <TextInput
                    label="Thời hạn công nợ"
                    placeholder={`Nhập thời hạn (tối đa ${
                      (customerCheck?.debtTerm || 0) * 2
                    } ngày)`}
                    withAsterisk
                    type="number"
                    value={
                      dataPaymentLatter
                        ? dataPaymentLatter?.debtInfo?.dueDate
                        : debtInfo.dueDate || ""
                    }
                    onChange={(e) => {
                      const newValue = e.target.value; // Lấy giá trị nhập vào
                      const numericValue = parseInt(newValue, 10);

                      // Cho phép giá trị rỗng hoặc số hợp lệ
                      if (
                        newValue === "" ||
                        (numericValue > 0 &&
                          numericValue <= (customerCheck?.debtTerm || 0) * 2)
                      ) {
                        setDebtInfo({ ...debtInfo, dueDate: newValue });
                      }
                    }}
                    onKeyDown={(e) => {
                      // Chặn nhập dấu '-' và ký tự 'e'
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "-" ||
                        e.key === "+"
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <Flex
                    justify="end"
                    mt="lg"
                    style={{
                      pointerEvents:
                        location?.state?.actionType === "payment" &&
                        orderStatus !== "DON_HANG_HOAN_THANH"
                          ? "auto"
                          : "none",
                    }}
                  >
                    <Button onClick={handleCloseModal} color="gray" mr="sm">
                      Hủy
                    </Button>
                    <Button
                      onClick={() => {
                        if (
                          debtInfo.dueDate === "" ||
                          parseInt(debtInfo.dueDate, 10) === 0
                        ) {
                          // Nếu giá trị nhập không hợp lệ (rỗng hoặc 0), có thể xử lý tại đây
                          console.log("Vui lòng nhập thời hạn công nợ hợp lệ");
                          return;
                        }
                        handleSaveDebt();
                      }}
                    >
                      Lưu
                    </Button>
                  </Flex>
                </Modal>

                {/* Modal Trả góp */}
                <Modal
                  opened={modalType === "Trả góp"}
                  onClose={handleCloseModal}
                  title="Nhập thông tin Trả góp"
                  centered
                >
                  <Tabs defaultValue="financialCompany">
                    {/* Tab Công ty tài chính */}
                    <Tabs.List>
                      <Tabs.Tab value="financialCompany">
                        Công ty tài chính
                      </Tabs.Tab>
                      <Tabs.Tab value="creditCard">Thẻ tín dụng</Tabs.Tab>
                    </Tabs.List>

                    <Tabs.Panel
                      value="financialCompany"
                      pt="sm"
                      style={{
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      {/* <TextInput
                      label="Tên công ty"
                      placeholder="Nhập tên công ty"
                      withAsterisk
                      value={installmentInfo.companyName}
                      onChange={(e) =>
                        setInstallmentInfo({
                          ...installmentInfo,
                          companyName: e.target.value,
                        })
                      }
                    /> */}

                      <Select
                        label="Tên công ty"
                        placeholder="Chọn công ty"
                        data={[{ value: "hdsaigon", label: "HDSAISON" }]}
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.companyName ||
                          installmentInfo.companyName
                        }
                        onChange={(value) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            companyName: value || "",
                          })
                        }
                      />
                      <TextInput
                        label="Mã hợp đồng"
                        placeholder="Nhập mã hợp đồng"
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.contractCode ||
                          installmentInfo.contractCode
                        }
                        onChange={(e) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            contractCode: e.target.value,
                          })
                        }
                      />
                    </Tabs.Panel>

                    {/* Tab Thẻ tín dụng */}
                    <Tabs.Panel
                      value="creditCard"
                      pt="sm"
                      style={{
                        pointerEvents:
                          location?.state?.actionType === "payment" &&
                          orderStatus !== "DON_HANG_HOAN_THANH"
                            ? "auto"
                            : "none",
                      }}
                    >
                      <Select
                        label="Loại thẻ"
                        placeholder="Chọn loại thẻ"
                        data={[
                          { value: "payoo", label: "PAYOO" },
                          { value: "alepay", label: "ALEPAY" },
                        ]}
                        withAsterisk
                        value={
                          dataPaymentLatter?.installmentInfo?.cardType ||
                          installmentInfo.cardType
                        }
                        onChange={(value) =>
                          setInstallmentInfo({
                            ...installmentInfo,
                            cardType: value || "",
                          })
                        }
                      />
                    </Tabs.Panel>
                  </Tabs>

                  <Flex
                    justify="end"
                    mt="lg"
                    style={{
                      pointerEvents:
                        location?.state?.actionType === "payment" &&
                        orderStatus !== "DON_HANG_HOAN_THANH"
                          ? "auto"
                          : "none",
                    }}
                  >
                    <Button onClick={handleCloseModal} color="gray" mr="sm">
                      Hủy
                    </Button>
                    <Button
                      onClick={() => {
                        handleSaveInstallment();
                      }}
                    >
                      Lưu
                    </Button>
                  </Flex>
                </Modal>
              </>
            </Grid>
          </Box>
        )}
        <Box>
          <Grid mt={5}>
            <Grid.Col span={12}>
              <Flex
                gap="xs"
                direction={{ base: "column", sm: "row" }}
                align="center"
                style={{
                  pointerEvents: "auto",
                }}
              >
                {/* Ghi chú đơn hàng */}
                <Textarea
                  readOnly={location?.state?.actionType === "payment"}
                  placeholder="Ghi chú đơn hàng"
                  size="lg"
                  style={{ flex: 1, cursor: "pointer" }}
                  defaultValue={orderHeader?.note || ""}
                  onChange={(e) => debouncedNoteChange(e.target.value)}
                />
                {/* Ghi chú thu ngân */}
                <Textarea
                  readOnly={location?.state?.actionType !== "payment"}
                  placeholder="Ghi chú thu ngân"
                  size="lg"
                  style={{ flex: 1 }}
                  defaultValue={orderHeader?.attribute23 || ""}
                  onChange={(e) => debouncedCashierNoteChange(e.target.value)}
                />
              </Flex>
            </Grid.Col>
          </Grid>
        </Box>

        <Flex columnGap={5}>
          {orderStatus === "DON_HANG_TAM" ? (
            <Flex mt={10} gap={"xs"}>
              <>
                {/* {location?.state?.actionType !== "doi" && !isHaveShiping && (
                  <Button
                    style={{ pointerEvents: "auto" }}
                    color="blue"
                    size="sm"
                    loading={loading}
                    disabled={
                      listAdd.length === 0 ||
                      location?.state?.actionType === "approved" ||
                      location?.state?.actionType === "view"
                    }
                    onClick={() => handleEditSalesOrder(false)}
                  >
                    Lưu
                  </Button>
                )} */}
                <Button
                  style={{ pointerEvents: "auto" }}
                  color="green"
                  size="sm"
                  loading={loading}
                  disabled={
                    listAdd.length === 0 ||
                    location?.state?.actionType === "approved" ||
                    location?.state?.actionType === "view"
                  }
                  onClick={() => handleEditSalesOrder(true)}
                >
                  Chốt đơn
                </Button>
              </>
            </Flex>
          ) : (
            orderStatus !== "DON_HANG_HOAN_THANH" && (
              <>
                {location?.state?.actionType === "payment" ? (
                  <>
                    <Flex mt={10} gap={"xs"}>
                      <Button
                        color="green"
                        size="sm"
                        disabled={deferredPayment < 0 || isDisableHoanThanh()}
                        onClick={() => openModalPaymentBase()}
                        mt={10}
                      >
                        Hoàn thành
                      </Button>
                    </Flex>
                    {(orderHeader?.amountDiscountTotal ||
                      orderHeader?.discountAddedTotal) && (
                      <Flex mt={10} gap={"xs"}>
                        <Button
                          color="blue"
                          size="sm"
                          disabled={isDisablePhanBo}
                          onClick={() => handleAllocateItems()}
                          mt={10}
                        >
                          Phân bổ
                        </Button>
                      </Flex>
                    )}
                  </>
                ) : (
                  <>
                    <Flex mt={10} gap={"xs"}>
                      {location?.state?.actionType !== "doi" &&
                        !isHaveShiping && (
                          <Button
                            style={{ pointerEvents: "auto" }}
                            color="cyan"
                            size="sm"
                            loading={loading}
                            disabled={
                              orderStatus === "DON_HANG_CHOT" ||
                              orderStatus === "DON_HANG_HUY" ||
                              location?.state?.actionType === "approved" ||
                              location?.state?.actionType === "view"
                            }
                            onClick={() => handleCreateSalesOrder(false)}
                          >
                            Lưu
                          </Button>
                        )}
                    </Flex>
                    <Flex mt={10} gap={"xs"}>
                      <Button
                        style={{ pointerEvents: "auto" }}
                        leftSection={<IconCheck size={18} />}
                        color="green"
                        size="sm"
                        loading={loading}
                        disabled={
                          orderStatus === "DON_HANG_CHOT" ||
                          orderStatus === "DON_HANG_HUY" ||
                          location?.state?.actionType === "approved" ||
                          location?.state?.actionType === "view"
                        }
                        onClick={() => handleCreateSalesOrder(true)}
                      >
                        Chốt đơn
                      </Button>
                    </Flex>
                  </>
                )}
              </>
            )
          )}
          {location?.state?.actionType === "approved" &&
            orderStatus === "DON_HANG_CHO_DUYET_GIAM" && (
              <>
                <Flex mt={10} gap={"xs"}>
                  <Button
                    color="cyan"
                    size="sm"
                    onClick={() => handleApprovedSalesOrder()}
                    style={{ pointerEvents: "auto" }}
                  >
                    Duyệt giảm
                  </Button>
                </Flex>
                <Flex mt={10} gap={"xs"}>
                  <Button
                    color="red"
                    size="sm"
                    onClick={() =>
                      handleDeleteOrder(orderHeader?.orderNumber, "approved")
                    }
                    style={{ pointerEvents: "auto" }}
                  >
                    Không duyệt
                  </Button>
                </Flex>
              </>
            )}
        </Flex>
      </Box>
    );
  };

  //#region openConfirmModal
  function openFormCustomer(isChooseCongNo: boolean) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin danh sách khách hàng</Title>
        </>
      ),
      size: "90vw",
      children: (
        <CustomerInformation
          isChooseCongNo={isChooseCongNo}
          handleChooseCustomer={handleChooseCustomer}
          navigate={navigate}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormVoucher(row: MRT_Row<dataOrderDetailTable>) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Màn hình chọn chính sách khuyến mãi</Title>
        </>
      ),
      size: "70vw",
      children: (
        <VoucherRefactor
          branchId={branchId || 0}
          idItem={row?.id}
          price={row.original.priceOnPriceList}
          handleSelectProductAddOn={handleSelectProductAddOn}
          handleSelectProductGift={handleSelectProductGift}
          handleSelectPromotionMain={handleSelectPromotionMain}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const openModalPayment = (priceVnPay: number) =>
    modals.openConfirmModal({
      title: <Title order={5}>Thanh toán VN PAY</Title>,
      children: (
        <PaymentMethod
          price={priceVnPay}
          productCode={orderHeader?.orderNumber}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "550px",
    });

  const openModalPaymentMb = (price: number, anotherPayment: number) =>
    modals.openConfirmModal({
      title: <Title order={5}>Thanh toán chuyển khoản</Title>,
      children: (
        <PaymentMethodMb
          isDVT={
            listBranch?.find(
              (item: any) => Number(item.value) === Number(branchId),
            )?.attr6 === "DVT"
          }
          isPaymentMbSuccess={isPaymentMbSuccess}
          setIsPaymentMbSuccess={setIsPaymentMbSuccess}
          setTransactionCodeMb={setTransactionCodeMb}
          selectedBankReserve={selectedBankReserve}
          transactionCodeReserve={transactionCodeReserve}
          setTransactionCodeReserve={setTransactionCodeReserve}
          setSelectedBankReserve={setSelectedBankReserve}
          customerCheck={customerCheck}
          orderNumber={orderHeader.orderNumber}
          setPaymentDone={setPaymentDone}
          paymentDone={paymentDone}
          price={price + anotherPayment}
          productCode={orderHeader?.orderNumber}
        />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "550px",
    });

  const openDeleteConfirmModal = (row: MRT_Row<dataOrderDetailTable>) => {
    return modals.openConfirmModal({
      title: "Bạn có chắc chắn xóa sản phẩm này?",
      children: (
        <Text size="lg" mt={15}>
          Bạn có chắc chắn muốn xóa ?
        </Text>
      ),
      labels: { confirm: "Xóa", cancel: "Thoát" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        const data = listAdd.filter((value) => value.id !== row.original.id);
        setListAdd(data);

        setListAdd((prevData) => {
          // xoá sp
          const data = prevData.filter(
            (item) =>
              item.id !== row.original?.id &&
              //xoá cả quà tặng kèm theo
              !row.original?.listIdGift?.includes(item?.id),
          );

          return data;
        });
      },
    });
  };

  const openModalDeliveryInformation = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Thông tin giao hàng</Title>,
      size: "70%",
      children: (
        <ModalDeliveryInformation
          listAddress={listAddress}
          attribute36={orderHeader?.attribute36}
          cod={
            containsDT(orderHeader?.orderNumber) &&
            location?.state?.actionType !== "doi"
              ? orderHeader?.amountTotal
              : deferredPayment - orderHeader?.amountPaid
          }
          readOnly={location?.state?.actionType === "view"}
          shipping={shipping}
          shipingVendor={shipingVendor}
          setShippingVendor={setShipingVendor}
          customerCheck={customerCheck}
          dataDeliveryInformation={dataDeliveryInformation}
          setDataDeliveryInformation={setDataDeliveryInformation}
          branchId={branchId ? branchId : orderHeader?.orgId}
          listAdd={listAdd}
          payType={orderHeader?.attribute24}
          setIsHaveShipping={setIsHaveShipping}
          isHaveVat={orderHeader?.printInvoiceCheck === 1}
          // setOrderHeader={setOrderHeader}
          orderHeader={orderHeader}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  function openFormShipCompany() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin đối tác giao vận</Title>
        </>
      ),
      size: "70vw",
      children: <ShipCompanyTable onSelect={handleSelectShipingVendor} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormShipDepartment() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin bộ phận giao vận</Title>
        </>
      ),
      size: "400px",
      children: <ChooseShipDepartment onSelect={handleSelectShipingVendor} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const openModalPaymentBase = async () => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận hoàn tất thanh toán</Title>,
      children: (
        <>
          <Flex justify={"end"} gap={20} mt={"sm"}>
            <Button
              color="gray"
              leftSection={<IconWindow size={18} />}
              onClick={() => {
                modals.closeAll();
              }}
            >
              Huỷ
            </Button>
            <Button
              leftSection={<IconCheck size={18} />}
              onClick={() => {
                handleCallApiPayment();
                // handleSendMessageOrderSuccsess();
                modals.closeAll();
              }}
            >
              Xác nhận
            </Button>
          </Flex>
        </>
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "400px",
      classNames: {
        title: "custom-modal-title",
        body: "custom-modal-body",
      },
    });
  };

  //#region Table sản phẩm
  const handleChangeRequestReduction = async (
    value: number | string,
    id: number,
    price: number,
  ) => {
    if (branchId) {
      setListAdd((prevList) => {
        return prevList.map((item) => {
          if (item.id === id) {
            const newValue =
              typeof value === "number" ? value : parseFloat(value);
            const validNewValue = isNaN(newValue) ? 0 : newValue;
            const newPriceFinal =
              price - validNewValue - (item.discountAmount || 0); // Thêm discountAmount
            return {
              ...item,
              discountAdded: validNewValue,
              priceFinal: newPriceFinal,
            };
          }
          return item;
        });
      });
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<dataOrderDetailTable>[]>(() => {
    return [
      {
        header: "STT",
        enableEditing: false,
        size: 30,
        Cell: ({ renderedCellValue, row }) => (
          <Text>{row.index === -1 ? "" : row.index + 1}</Text>
        ),
      },
      {
        accessorKey: "lineTyle",
        header: "Loại",
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Text>
            <LineType status={row?.original?.lineTyle} />
          </Text>
        ),
        size: 110,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Box style={{ pointerEvents: "auto" }}>
            <Tooltip label={renderedCellValue}>
              <Text w={200} style={{ whiteSpace: "normal" }} lineClamp={2}>
                {renderedCellValue}
              </Text>
            </Tooltip>
          </Box>
        ),
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        enableEditing: isCreating,
        enableSorting: false,
        size: 120,
        Edit: ({ cell, row, table, column }) => {
          return (
            <>
              <Menu
                opened={!!valueDebounced && dataProducts?.length > 0}
                trapFocus={false}
                shadow="md"
                width={"800"}
                position="bottom-start"
              >
                <Menu.Target>
                  <TextInput
                    autoFocus
                    onChange={async (e) => {
                      const _key = e.target.value ?? "";
                      setValueDebounced(_key);
                      handleSearch();
                    }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      if (
                        e.key === "Enter" &&
                        dataProducts?.length === 1 &&
                        !listAdd.some(
                          (item) => item.itemCode === e.currentTarget.value,
                        )
                      ) {
                        setValueDebounced("");
                        handleSelectProduct(dataProducts[0], row?.index);
                        table.setCreatingRow(null);
                        handleSearch();
                      }
                    }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  {/* Nút đóng góc trên */}
                  <ActionIcon
                    onClick={() => {
                      setValueDebounced(""); // Đóng menu khi nút đóng được bấm
                      handleSearch();
                    }}
                    style={{
                      position: "absolute",
                      top: 4, // Điều chỉnh khoảng cách từ trên xuống
                      right: 20, // Điều chỉnh khoảng cách từ phải sang
                      zIndex: 11,
                      backgroundColor: "#f5f5f5", // Màu nền nhạt
                      border: "1px solid #ccc", // Viền nhẹ
                      borderRadius: "4%", // Bo tròn hoàn toàn
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)", // Hiệu ứng bóng
                      color: "#000", // Màu biểu tượng
                      width: "22px", // Kích thước nút
                      height: "2px", // Kích thước nút
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease", // Hiệu ứng mượt mà
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e0e0e0"; // Màu nền khi hover
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Trả về màu nền ban đầu
                    }}
                    variant="transparent"
                  >
                    <IconX size={22} />
                  </ActionIcon>

                  {modeSearch === "SP" ? (
                    <TableSelect
                      dataProducts={dataProducts}
                      onSelectProduct={(product) => {
                        handleSelectProduct(product, row?.index);
                      }}
                      rowIndex={row.index}
                    />
                  ) : (
                    <TableSelectDV
                      dataProducts={dataProducts}
                      onSelectProduct={(product) => {
                        handleSelectProduct(product, row?.index, "DV");
                      }}
                      rowIndex={row.index}
                    />
                  )}
                </Menu.Dropdown>
              </Menu>
            </>
          );
        },
      },

      {
        accessorKey: "attribute23", // Khóa để truy cập dữ liệu
        header: "Mã kho", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return <Text>{row?.original?.attribute23}</Text>; // Hiển thị giá trị
        },
      },

      {
        accessorKey: "primaryUomCode",
        header: "ĐVT",
        enableEditing: false,
        enableSorting: false,
        size: 50,
      },

      {
        accessorKey: "quality",
        header: "Số lượng",
        enableEditing: false,
        enableSorting: false,
        size: 80,
        Cell: ({ renderedCellValue, row }) => (
          <NumberInput
            disabled={!row?.original?.itemCode}
            min={1}
            max={10000}
            hideControls
            clampBehavior="strict"
            value={row.original.quality}
            onChange={(e) => {
              handleChangeQuantity(e, row);
            }}
            onBlur={(e) => {
              table.setEditingCell(null);
            }}
            onKeyDown={handleKeyDown}
            defaultValue={1}
            allowDecimal={false}
            allowNegative={false}
          />
        ),
      },
      {
        accessorKey: "priceOnPriceList",
        header: "Giá TMĐT",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => {
          // if (location?.state?.isReadOnly) {
          if (false) {
            // Trạng thái chỉ đọc, không hiển thị gì
            return null;
          }

          if (row.original.lineTyle === "DV") {
            return (
              <Flex direction="column" gap="sm" rowGap={1}>
                <Flex align="center">
                  <NumberInput
                    size="sm"
                    placeholder="Nhập giá"
                    value={row.original.priceOnPriceList}
                    onChange={(value) => {
                      if (value !== null) {
                        // Giới hạn giá trị tối đa là 100 triệu
                        const newValue = Math.min(
                          Number(value) || 0,
                          100000000,
                        );
                        setListAdd((prevData) =>
                          prevData.map((item, i) =>
                            i === row.index
                              ? {
                                  ...item,
                                  priceFinal: newValue * item?.quality,
                                  priceOnPriceList: newValue,
                                }
                              : item,
                          ),
                        );
                      }
                    }}
                    onKeyDown={(event) => {
                      // Ngăn không cho nhập '-' và 'e'
                      if (
                        event.key === "-" ||
                        event.key === "e" ||
                        event.key === "E"
                      ) {
                        event.preventDefault();
                      }
                    }}
                    hideControls
                    max={100000000} // Thiết lập giá trị tối đa
                    thousandSeparator="."
                    decimalSeparator=","
                    styles={{
                      input: {
                        height: "30px",
                        fontSize: "14px",
                        padding: "4px",
                      },
                    }}
                  />
                </Flex>
              </Flex>
            );
          } else {
            return (
              <Flex direction="column">
                <NumberFormatter
                  value={row.original.priceOnPriceList}
                  thousandSeparator="."
                  decimalSeparator=","
                />
              </Flex>
            );
          }
        },
      },

      // {
      //   header: "KM",
      //   enableEditing: false,
      //   enableSorting: false,
      //   size: 120,
      //   Cell: ({ row }) => {
      //     const [customDiscount, setCustomDiscount] = React.useState<
      //       number | null
      //     >(row.original.discountAmount || null);
      //     const [warning, setWarning] = React.useState<string | null>(null);

      //     // Hàm cập nhật giá trị vào danh sách
      //     const handleDiscountChange = (value: number | null) => {
      //       if (value !== null && value > row.original.priceOnPriceList) {
      //         setWarning("KM không được lớn hơn giá sản phẩm");
      //         return;
      //       }
      //       setWarning(null);
      //       setCustomDiscount(value);

      //       setListAdd((prevData) =>
      //         prevData.map((item, i) => {
      //           if (i === row.index) {
      //             const updatedDiscountAmount = value || 0;
      //             const updatedPriceFinal =
      //               row.original.priceOnPriceList -
      //               updatedDiscountAmount -
      //               (row.original.discountAdded || 0);

      //             return {
      //               ...item,
      //               discountAmount: updatedDiscountAmount,
      //               priceFinal: updatedPriceFinal > 0 ? updatedPriceFinal : 0, // Đảm bảo không âm
      //             };
      //           }
      //           return item;
      //         })
      //       );
      //     };

      //     const calculatedDiscount =
      //       customDiscount ??
      //       (row.original.discountRate
      //         ? -(
      //             (row.original.discountRate * row.original.priceOnPriceList) /
      //             100
      //           )
      //         : -(row.original.discountAmount || 0));

      //     return (
      //       <Flex
      //         direction="column"
      //         align="start"
      //         style={{
      //           padding: "5px",
      //           borderRadius: "6px",
      //           border: "1px solid #ddd",
      //           backgroundColor: "#f9f9f9",
      //           gap: "5px",
      //         }}
      //       >
      //         {/* Giá trị giảm hiển thị */}
      //         <Flex
      //           align="center"
      //           justify="space-between"
      //           style={{ width: "100%" }}
      //         >
      //           <Box style={{ fontWeight: 600 }}>Giảm CTKM:</Box>
      //           <Box style={{ color: "red", fontWeight: 600, marginRight: 4 }}>
      //             <NumberFormatter
      //               value={calculatedDiscount}
      //               thousandSeparator="."
      //               decimalSeparator=","
      //             />
      //           </Box>
      //         </Flex>

      //         {/* Ô nhập liệu riêng biệt */}
      //         <Flex
      //           align="center"
      //           justify="space-between"
      //           style={{ width: "100%" }}
      //         >
      //           <Box style={{ fontWeight: 600 }}>Giảm tự nhập:</Box>
      //           <NumberInput
      //             size="xs"
      //             hideControls
      //             value={customDiscount ?? ""}
      //             onChange={(e) => handleDiscountChange(Number(e) || null)}
      //             thousandSeparator="."
      //             decimalSeparator=","
      //             style={{
      //               width: "60px",
      //               marginLeft: "4px",
      //               borderRadius: "4px",
      //             }}
      //           />
      //         </Flex>

      //         {/* Hiển thị cảnh báo nếu có */}
      //         {warning && (
      //           <Box
      //             style={{
      //               color: "orange",
      //               fontSize: "12px",
      //               marginTop: "5px",
      //               textAlign: "center",
      //             }}
      //           >
      //             {warning}
      //           </Box>
      //         )}
      //       </Flex>
      //     );
      //   },
      // },

      // {
      //   accessorKey: "discount",
      //   header: "Xin giảm",
      //   enableEditing: false,
      //   enableSorting: false,
      //   size: 130,
      //   Cell: ({ renderedCellValue, row }) => {
      //     // Tạo hàm debounce với Mantine
      //     const debouncedHandleChange = useDebouncedCallback(
      //       (value) => {
      //         handleChangeRequestReduction(
      //           value,
      //           row.original.id,
      //           row?.original?.priceOnPriceList
      //         );
      //       },
      //       500 // 300ms là thời gian debounce
      //     );

      //     return (
      //       <NumberInput
      //         disabled={
      //           Number(orderHeader?.discountAddedTotal) > 0
      //             ? true
      //             : false ||
      //               row?.original?.lineTyle !== "HH" ||
      //               location?.state?.actionType === "payment" ||
      //               row?.original?.attribute11 === "G" ||
      //               row?.original?.attribute11 === "H"
      //         }
      //         style={{ height: 35 }}
      //         size="sm"
      //         fw={"500"}
      //         hideControls
      //         thousandSeparator="."
      //         decimalSeparator=","
      //         value={row.original?.discountAdded}
      //         onChange={(e) => {
      //           debouncedHandleChange(e);
      //         }}
      //         min={1}
      //         max={1000000000}
      //         clampBehavior="strict"
      //         onKeyDown={handleKeyDown}
      //         allowDecimal={false}
      //         allowNegative={false}
      //       />
      //     );
      //   },
      // },
      {
        header: "KM",
        enableEditing: false,
        enableSorting: false,
        size: 80,
        Cell: ({ row }) => {
          return (
            <NumberFormatter
              value={calculateKmPerLine(row.original)}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "priceFinal",
        header: "Thành tiền",
        size: 80,
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => {
          // if (location?.state?.isReadOnly) {
          if (false) {
            // Trạng thái chỉ đọc, không hiển thị gì
            return null;
          }

          const { priceFinal, quality } = row.original;
          // Đảm bảo không có giá âm
          const displayedPrice = Math.max(priceFinal * quality, 0);

          return (
            <>
              <NumberFormatter
                value={displayedPrice}
                thousandSeparator="."
                decimalSeparator=","
              />
            </>
          );
        },
      },
      {
        accessorKey: "attribute20",
        header: "Bảo hành",
        size: 80,
        enableEditing: false,
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => {
          return <>{renderedCellValue ? `${renderedCellValue} tháng` : ""}</>;
        },
      },
      {
        accessorKey: "attribute28", // Khóa để truy cập dữ liệu
        header: "Phí sàn phân bổ", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return (
            <NumberFormatter
              value={Math.round(Number(row?.original?.attribute28) || 0) || ""}
              thousandSeparator="."
              decimalSeparator=","
            />
          ); // Hiển thị giá trị
        },
      },
      // {
      //   accessorKey: "attribute29", // Khóa để truy cập dữ liệu
      //   header: "Xin giảm phân bổ", // Tiêu đề của cột
      //   enableEditing: false, // Không cho phép chỉnh sửa
      //   enableSorting: false, // Tắt sắp xếp
      //   size: 80, // Độ rộng của cột
      //   Cell: ({ row }) => {
      //     return (
      //       <NumberFormatter
      //         value={Math.round(Number(row?.original?.attribute29) || 0) || ""}
      //         thousandSeparator="."
      //         decimalSeparator=","
      //       />
      //     );
      //   },
      // },
      {
        accessorKey: "attribute35", // Thành tiền sau bổ
        header: "Thành tiền sau bổ", // Tiêu đề của cột
        enableEditing: false, // Không cho phép chỉnh sửa
        enableSorting: false, // Tắt sắp xếp
        size: 80, // Độ rộng của cột
        Cell: ({ row }) => {
          return (
            <NumberFormatter
              value={Math.round(Number(row?.original?.attribute35) || 0) || ""}
              thousandSeparator="."
              decimalSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
        enableSorting: false,
        enableEditing: false,
        size: 120,
        Cell: ({ row }) => (
          <TextInput
            value={row.original.note || ""}
            onChange={(event) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, note: event.target.value }
                    : item,
                ),
              );
            }}
          />
        ),
      },
      {
        accessorKey: "attribute16",
        header: "Chứng từ DV",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => (
          <TextInput
            disabled={row.original.lineTyle !== "DV"}
            value={row.original.attribute16 || ""}
            onChange={(event) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute16: event.target.value }
                    : item,
                ),
              );
            }}
          />
        ),
      },
      {
        accessorKey: "attribute17",
        header: "Giá DV",
        enableEditing: false,
        enableSorting: false,
        size: 120,
        Cell: ({ row }) => (
          <NumberInput
            disabled={row.original.lineTyle !== "DV"}
            value={row.original.attribute17 || 0} // Giá trị mặc định
            onChange={(value) => {
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute17: Number(value) } // Đảm bảo giá trị là số
                    : item,
                ),
              );
            }}
            thousandSeparator="."
            decimalSeparator=","
            hideControls
            min={0}
            step={1000}
            placeholder="Nhập số tiền"
          />
        ),
      },
      {
        accessorKey: "attribute15",
        header: "LK giàn",
        enableSorting: false,
        enableEditing: false,
        size: 100,
        Cell: ({ row }) => (
          <Checkbox
            checked={row?.original?.attribute15 === "1"}
            onChange={(event) => {
              const isChecked = event.currentTarget.checked;
              setListAdd((prevData) =>
                prevData.map((item, i) =>
                  i === row.index
                    ? { ...item, attribute15: isChecked ? "1" : "0" }
                    : item,
                ),
              );
            }}
          />
        ),
      },
    ];
  }, [listAdd, dataProducts, isCreating, orderHeader?.discountAddedTotal]);

  const table = useMantineReactTable<dataOrderDetailTable>({
    columns,
    data: listAdd,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "Thao tác",
      },
    },
    positionToolbarAlertBanner: "bottom",
    createDisplayMode: "row",
    editDisplayMode: "cell",
    enableEditing: true,
    enableRowActions: true,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableTopToolbar: false,
    enableBatchRowSelection: true,
    positionActionsColumn: "last",
    enableExpandAll: false,

    renderRowActions: ({ row, table }) => (
      <Flex gap="4">
        {!row?.original?.attribute11 && (
          <>
            <Tooltip label="Chọn chính sách khuyến mãi">
              <ActionIcon
                color={orange.base}
                variant="outline"
                disabled={
                  row.original?.listIdPromotion?.length < 1 ||
                  !row.original?.listIdPromotion?.length ||
                  row?.original?.lineTyle === "DV"
                }
                onClick={async () => {
                  openFormVoucher(row);
                }}
              >
                <IconDiscount
                  style={{
                    color:
                      row.original?.listIdPromotion?.length < 1 ||
                      !row.original?.listIdPromotion?.length ||
                      row?.original?.lineTyle === "DV"
                        ? "gray"
                        : orange.base,
                  }}
                />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xoá sản phẩm">
              <ActionIcon variant="outline" color="red">
                <IconTrash onClick={() => openDeleteConfirmModal(row)} />
              </ActionIcon>
            </Tooltip>
          </>
        )}
      </Flex>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
          mb={"xs"}
          style={{ opacity: 0 }}
        ></Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localizationSales,
    getRowId: (row) => row.id?.toString(),
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    initialState: {
      expanded: true,
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-expand"],
        right: ["mrt-row-actions"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },

    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualSorting: false,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        ...styleCellTable(row),
        ...getStyle(true),
      },
    }),
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        backgroundColor: handleCheckBackgroundColor(
          row?.original?.attribute11 || "",
        ),
      },
    }),
    enablePagination: false,
    enableBottomToolbar: false,
    state: {
      showAlertBanner: isError,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    enableColumnPinning: true,
    mantineTableProps: {},
  });

  //#region useEffect

  useHotkeys([
    ["mod+J", () => console.log("Toggle color scheme")],
    [
      "ctrl+F5",
      () => {
        //  openNew();
      },
    ],
    [
      "F5",
      () => {
        //  openNew();
      },
    ],
    ["alt+mod+shift+X", () => console.log("Rick roll")],
    [
      "F11",
      () => {
        // openNew(true);
      },
    ],
    ["ctrl+M", () => toggleCollapse()],
  ]);

  useEffect(() => {
    const total = [cardPayment, cashPayment, vnpayPayment, bankTransfer]
      .filter((value) => value > 0) // Filter out values that are 0 or less
      .reduce((acc, curr) => acc + curr, 0); // Sum up the remaining values

    setTotalPaid(total);
  }, [cardPayment, cashPayment, vnpayPayment, bankTransfer]);

  useEffect(() => {
    if (selectedWarehouse?.branchId) {
      setBranchId(selectedWarehouse?.branchId);
      const name = listBranch?.find(
        (item: any) => item?.value == selectedWarehouse?.branchId,
      );
      setBranchName(name?.text);
      const updatedList = listAdd.map((item) => ({
        ...item,
        attribute23: selectedWarehouse.subInvCode,
        warehouse: selectedWarehouse.branchName,
        subInvId: selectedWarehouse.subInvId,
      }));

      setListAdd(updatedList);
    }
  }, [selectedWarehouse, listBranch]);

  useEffect(() => {
    if (dataAllocate?.length > 0) {
      setListAdd((prevListAdd) => {
        return prevListAdd.map((item) => {
          const matchedAllocation: any = dataAllocate.find(
            (allocation: any) => allocation.itemId === item.itemId,
          );

          if (matchedAllocation) {
            const priceAfterAllocation =
              (item.priceFinal -
                matchedAllocation?.priceAllKM -
                matchedAllocation?.priceAll) *
              item.quality;

            return {
              ...item,
              attribute28: matchedAllocation?.priceAllKM,
              attribute29: matchedAllocation?.priceAll,
              attribute35: priceAfterAllocation.toString() || "", // Thành tiền sau khi phân bổ
            };
          }
          return item; // Trả về item gốc nếu không tìm thấy dữ liệu phù hợp trong dataAllocate
        });
      });
    }
  }, [dataAllocate]);

  useEffect(() => {
    setDeferredPayment(payableAmount - totalPaid);
  }, [payableAmount, totalPaid]);

  useEffect(() => {
    const fetchDataCreate = async () => {
      const url = `/api/v1/CreateSellItem/create?codePrefix=DH`;
      try {
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success && !orderHeader?.orderNumber) {
          setOrderHeader(response.data.orderHeader);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (orderHeader?.orderNumber || isFetchDataCalledRef.current) return;

    if (
      location?.state?.actionType !== "view" &&
      location?.state?.actionType !== "payment" &&
      location?.state?.actionType !== "edit" &&
      location?.state?.actionType !== "approved" &&
      location?.state?.actionType !== "doi"
    ) {
      fetchDataCreate();
      isFetchDataCalledRef.current = true; // Đặt flag để tránh gọi lại
    }
  }, [orderHeader, location?.state]);

  useEffect(() => {
    if (branchId && branchName) return;
    setBranchId(orderHeader?.orgId || 0);
    const name = listBranch?.find(
      (item: any) => item?.value == orderHeader?.orgId,
    );
    setBranchName(name?.text);
  }, [orderHeader, listBranch]);

  useEffect(() => {
    const handleCheckPayableAmount = (listAdd: any[]) => {
      let priceTotal = 0;

      if (location?.state?.actionType === "doi") {
        listAdd?.forEach((item) => {
          console.log("vvvvvv", item);
          if (item?.attribute14 || item?.attribute2) {
            // Tính giá sản phẩm và cộng thêm attribute11 và attribute12
            const itemPrice =
              (item?.priceOnPriceList || 0) * (item?.quality || 0);
            const additionalAmount =
              (parseFloat(item?.attribute5) || 0) +
              (parseFloat(item?.attribute12) || 0);
            priceTotal += itemPrice + additionalAmount;
          }
        });
      } else {
        listAdd?.forEach((item) => {
          priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
        });
      }

      return priceTotal;
    };
    setListSerial(handleRenderOptionListAdd(listAdd));
    let priceTotal = handleCheckPayableAmount(listAdd);

    setTotalAmount(priceTotal);
    let totalXGDetail = listAdd.reduce((acc, item) => {
      const discountAdded = item.discountAdded || 0; // Lấy giá trị xin giảm, mặc định là 0 nếu không có
      return acc + discountAdded * (item.quality || 1); // Cộng dồn vào tổng, nhân với số lượng
    }, 0);
    const totalDiscount = listAdd.reduce((acc, item) => {
      const discountAmount = item.discountAmount || 0; // Lấy giá trị giảm giá, mặc định là 0 nếu không có
      return acc + discountAmount * (item.quality || 1); // Cộng dồn vào tổng, nhân với số lượng
    }, 0);

    const totalDiscountRate = listAdd.reduce((acc, item) => {
      const discountRate = item.discountRate || 0; // Giá trị phần trăm giảm giá
      const price = item.priceOnPriceList || 0; // Giá của sản phẩm
      const quality = item.quality || 1; // Số lượng sản phẩm
      const discountValue = (discountRate / 100) * price * quality; // Tính giá trị giảm giá
      return acc + discountValue; // Cộng dồn vào tổng
    }, 0);

    setTotalXGDetail(totalXGDetail); // Cập nhật tổng xin giảm
    setTotalKM(
      totalDiscount +
        totalDiscountRate +
        (orderHeader?.amountDiscountTotal || 0),
    );
    setTotalKMLine(totalDiscount + totalDiscountRate);
    setPayableAmount(
      (priceTotal ?? 0) -
        (totalDiscount ?? 0) -
        (totalDiscountRate ?? 0) -
        (orderHeader?.amountDiscountTotal ?? 0) -
        (totalXGDetail ?? 0) -
        (orderHeader?.discountAddedTotal ?? 0),
    );
  }, [listAdd, orderHeader, location?.state?.actionType]);

  // hàm lấy data ban đầu
  useEffect(() => {
    const userLogin = localStorage.getItem("userLogin");

    if (userLogin) {
      const userLoginObject = JSON.parse(userLogin);
      // gán người thanh toán chính là người bấm nút hoàn thành
      setUserLogin(userLoginObject);
    }

    const fetchDataBranch = async () => {
      const response = await repositoryPos.get<
        MessageResponse<TblDMPaymentMethod[]>
      >("/api/v1/TblDmInventory/get-select-branch?auth=false");

      if (response && response.success) {
        let result = response.data;
        setListBranch(result);
      }
    };

    const fetchDataSaleChanelId = async () => {
      const response = await repositoryMdm.get<MessageResponse<any[]>>(
        "/api/v1/TblDmSaleChanel/get-all",
      );

      if (response && response.success) {
        let result = response.data;
        setSaleChanelList(result);
      }
    };

    const fetchAllDepartment = async () => {
      const response = await repositoryPos.get<
        MessageResponse<DepartmentModel[]>
      >(`/api/v1/TblDepartment/get-all`);

      if (response && response.success) {
        let result = response.data;
        setListDepartment(result);
      } else {
      }
    };

    Promise.all([
      fetchDataSaleChanelId(),
      fetchAllDepartment(),
      fetchDataBranch(),
    ]);
  }, []);

  const [searchTrigger, setSearchTrigger] = useState(0);

  useEffect(() => {
    const fetchItemSell = async () => {
      const keySearch = valueDebounced.toLowerCase();
      const url =
        modeSearch === "SP"
          ? `/api/v1/TblItem/search-sell?inv=${branchId}&key=${keySearch}`
          : `/api/v1/TblItem/search-sell-service?inv=${branchId}&key=${keySearch}`;
      try {
        const searchResult =
          await repositoryPos.get<MessageResponse<ProductModel[]>>(url);
        if (searchResult?.data) {
          setDataProducts(searchResult.data);
        } else {
          setDataProducts([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setDataProducts([]);
      }
    };

    if (valueDebounced && valueDebounced.length > 2) {
      fetchItemSell();
    } else {
      setDataProducts([]);
    }
  }, [valueDebounced, branchId, modeSearch, searchTrigger]);

  const handleSearch = () => {
    setSearchTrigger((prev) => prev + 1); // Kích hoạt lại useEffect
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (270 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // Noti nếu thanh toán trước hơn thanh toán sau
  useEffect(() => {
    if (
      deferredPayment < 0 &&
      totalAmount !== 0 &&
      location?.state?.actionType !== "doi"
    ) {
      NotificationExtension.Warn(
        "Số tiền thanh toán lớn hơn tổng số tiền cần thanh toán của đơn!",
      );
    }
  }, [deferredPayment]);

  //region logic chọn chi nhánh
  useEffect(() => {
    const fetchDepartmentByBanchId = async () => {
      if (branchId) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDepartment/get-all?branchId=${branchId}`,
        );
        if (response && response.success) {
          let result = response.data;
          setListDepartment(result);
        }
      }
    };
    fetchDepartmentByBanchId();
  }, [branchId]);

  useEffect(() => {
    const fetchEmployeeByDepartmentId = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        let result = response.data;
        setListEmployeeSales(result);
      }
    };
    fetchEmployeeByDepartmentId();
  }, []);

  //region  logic sửa đơn hàng

  const fetchDetailSaleChanel = async (SaleChanelId: number) => {
    if (SaleChanelId) {
      const response = await repositoryMdm.get<MessageResponse<any>>(
        `/api/v1/TblDmSaleChanel/update?id=${SaleChanelId}`,
      );
      if (response && response.success) {
        let result = response.data;
        setSaleChanel(result?.name);
      }
    }
  };

  const fetchDelivery = async (data: string) => {
    try {
      const parsedData = JSON?.parse(data);
      setDataDeliveryInformation((prev: any) => ({
        ...prev,
        branchId: parsedData?.branchId,
        customerAddress: parsedData?.customerAddress,
        customerCommuneId: parsedData?.customerCommuneId,
        customerDistrictId: parsedData?.customerDistrictId,
        customerId: parsedData?.customerId,
        customerName: parsedData?.customerName,
        customerProvinceId: parsedData?.customerProvinceId,
        depId: parsedData?.depId,
        sourceType: parsedData?.sourceType,
        telephoneNumber: parsedData?.telephoneNumber,
        deliveryAppointmentTime: new Date(),
        deliveryFee: parsedData?.deliveryFee,
        timeDelivery: parsedData?.timeDelivery,
        timeDeliveryTime: parsedData?.timeDeliveryTime,
        weight: parsedData?.weight,
        width: parsedData?.width,
        length: parsedData?.length,
        height: parsedData?.height,
        feeShip: parsedData?.feeShip,
        description: parsedData?.description,
        status: parsedData?.status,
        typeShip: parsedData?.typeShip,
        to_address: parsedData?.to_address,
        distance: parsedData?.distance,
        to_addressid: parsedData?.to_addressid,
        transportName: parsedData?.transportName,
        listAddress: parsedData?.listAddress || [],
      }));
    } catch (error) {
      console.error("JSON parsing failed:", error);
    }
  };

  // thêm logic bo phan sẽ ăn theo người hưởng số
  useEffect(() => {
    const foundEmployee = listEmployeeSales.find(
      (emp) => emp.id == employeeSalesRevenueId,
    );

    if (foundEmployee?.departmentId) {
      setDepartmentId(foundEmployee?.departmentId);
    }
  }, [employeeSalesRevenueId, listEmployeeSales]);

  useEffect(() => {
    if (
      !location?.state ||
      location?.state?.actionType === "view" ||
      location?.state?.actionType === "doi"
    )
      return;
    const fetchDataPaymentMethod = async () => {
      if (location.state?.orderNumber) {
        const url =
          location?.state?.actionType === "approved"
            ? `/api/v1/CreateSellItem/approve?orderNumber=${location.state?.orderNumber}`
            : location?.state?.actionType === "edit"
              ? `/api/v1/CreateSellItem/edit?orderNumber=${location.state?.orderNumber}`
              : `/api/v1/CreateSellItem/payment?orderNumber=${location.state?.orderNumber}`;

        const response = await repositoryPos.get<MessageResponse<any>>(url);

        if (response && response.success) {
          let result = response.data;
          setOrderHeader({ ...result.orderHeader });
          if (result?.orderHeader?.attribute57) {
            try {
              const parsedTaxInfo = JSON.parse(result.orderHeader.attribute57);
              setTaxInfo(parsedTaxInfo);
            } catch (e) {}
          }
          setOrderStatus(result?.orderHeader?.orderStatus);
          setBranchId(result?.orderHeader?.orgId);
          setShipingVendor(result?.orderHeader?.shipingVendor);
          const branchName = listBranch?.find(
            (item: any) => item?.id == result?.orderHeader?.orgId,
          );

          // Kiểm tra nếu branchName tồn tại trước khi set
          if (branchName) {
            setBranchName(branchName?.text);
          }
          if (!result?.orderDetail) return;
          setListAdd(result.orderDetail);
        }
      }
    };
    fetchDataPaymentMethod();
  }, [location, listBranch]);

  useEffect(() => {
    if (!location?.state) return;

    const handleFetchDataCustomer = async () => {
      const customerId =
        location?.state?.actionType === "doi"
          ? orderHeaderRef?.custId
          : orderHeader?.custId;

      if (customerId) {
        const customerReturn = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmCustomer/get-detail?id=${customerId}`,
        );

        console.log("customerReturn", customerReturn);

        setCustomerCheck((prev) => ({
          ...prev,
          active: customerReturn?.data?.active ?? false,
          address: customerReturn?.data?.address ?? "",
          birthOfDate: customerReturn?.data?.birthOfDate ?? null,
          code: customerReturn?.data?.code ?? "",
          contact: customerReturn?.data?.contact ?? "",
          description: customerReturn?.data?.description ?? "",
          email: customerReturn?.data?.email ?? "",
          fax: customerReturn?.data?.fax ?? "",
          groupId: customerReturn?.data?.groupId ?? 0,
          id: customerReturn?.data?.id ?? 0,
          name: customerReturn?.data?.name ?? "",
          companyName: customerReturn?.data?.companyName ?? "",
          sex: customerReturn?.data?.sex ?? null,
          taxCode: customerReturn?.data?.taxCode ?? "",
          telephoneNumber: customerReturn?.data?.telephoneNumber ?? "",
          type: customerReturn?.data?.type ?? 0,
          attribute1: customerReturn?.data?.attribute1 ?? "",
          attribute4: customerReturn?.data?.attribute4 ?? "",
          // debtLimit: customerReturn?.data?.debtLimit ?? 0,
          // debtTerm: customerReturn?.data?.debtTerm ?? 0,
        }));
      }
    };

    handleFetchDataCustomer();
  }, [orderHeader, location?.state, orderHeaderRef]);

  useEffect(() => {
    if (location?.state && !location?.state?.orderNumberOld) {
      fetchDetailSaleChanel(orderHeader?.saleChanelId);
      setContractcode(orderHeader?.contractcode);
      fetchDelivery(orderHeader?.attribute1 || "");
      setShipping(orderHeader?.shipngType);
      setAccountantId(orderHeader?.attribute2 || 0);
      handleGetNameAccountantById(orderHeader?.attribute2);
    }
  }, [orderHeader, location]);

  useEffect(() => {
    const fetchDepartment = async (DeptId: number) => {
      setDepartmentId(DeptId);
      const DeptName = listDepartment.find((item) => {
        return item.departmentId === DeptId;
      });
      if (DeptName?.name) {
        setDepartment(DeptName?.name || "");
      }
    };

    const fetchDetailEmployeeSales = async (
      SaleId: number,
      attribute18?: string,
    ) => {
      if (SaleId && SaleId != 0) {
        const response = await repositoryPos.get<MessageResponse<any>>(
          `/api/v1/TblDmEmployee/detail-employee?id=${SaleId}`,
        );
        if (response && response.success) {
          let result = response.data;
          setEmployeeSalesId(SaleId.toString());
          setEmployeeSalesName(result?.fullName);
          if (
            location?.state?.actionType !== "payment" &&
            location?.state?.actionType !== "approved" &&
            location?.state?.actionType !== "view" &&
            location?.state?.actionType !== "edit"
          ) {
            setEmployeeSalesRevenueId(SaleId.toString());
            setEmployeeSalesRevenueName(result?.fullName);
          } else {
            if (attribute18 && attribute18 != "0") {
              const response = await repositoryPos.get<MessageResponse<any>>(
                `/api/v1/TblDmEmployee/detail-employee?id=${attribute18}`,
              );
              if (response && response.success) {
                let resultRevenue = response.data;
                setEmployeeSalesRevenueId(attribute18 || "");
                setEmployeeSalesRevenueName(resultRevenue?.fullName);
              }
            }
          }
        }
      }
    };
    fetchDepartment(orderHeader?.deptId);
    fetchDetailEmployeeSales(orderHeader?.saleId, orderHeader?.attribute18);
  }, [
    orderHeader?.deptId,
    orderHeader?.saleId,
    listDepartment,
    location,
    orderHeader?.attribute18,
  ]);

  // logic xem đơn
  useEffect(() => {
    const handleViewSalesOrder = async () => {
      if (
        location?.state?.actionType === "payment" ||
        location?.state?.actionType === "approved"
      ) {
        const url = `/api/v1/CreateSellItem/details?orderNumber=${location.state.orderNumber}`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          if (response?.data?.orderHeader?.shipingVendor) {
            setShipingVendor(response?.data?.orderHeader?.shipingVendor);
          }
        }
      }

      if (location?.state?.actionType === "view") {
        const url = `/api/v1/CreateSellItem/details?orderNumber=${location.state.orderNumber}`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          setOrderHeader({ ...response?.data?.orderHeader });
          if (response?.data?.orderHeader?.attribute57) {
            try {
              const parsedTaxInfo = JSON.parse(
                response.data.orderHeader.attribute57,
              );
              setTaxInfo(parsedTaxInfo);
            } catch (e) {}
          }
          setDataPayment(JSON.parse(response?.data?.orderHeader?.attribute9));
          if (response?.data?.orderHeader?.shipingVendor) {
            setShipingVendor(response?.data?.orderHeader?.shipingVendor);
          }
          setDataPaymentLatter(
            JSON.parse(response?.data?.orderHeader?.attribute20),
          );
          setPayLaterMethod(
            JSON.parse(response?.data?.orderHeader?.attribute20)
              ?.payLaterMethod,
          );
          setListAdd(response.data.orderDetail);
          setOrderStatus(response?.data?.orderHeader?.orderStatus);
        }
      }
    };

    handleViewSalesOrder();
  }, [location]);

  // logic doi tra
  useEffect(() => {
    const handleViewSalesOrder = async () => {
      if (location?.state?.actionType === "doi") {
        const url = `/api/v1/CreateSellItem/details-return?orderNumber=${location.state.orderNumberOld}&check=false`;
        const response = await repositoryPos.get<MessageResponse<any>>(url);
        if (response && response?.success) {
          setOrderHeader({ ...response?.data?.orderHeader });
          if (response?.data?.orderHeader?.attribute57) {
            try {
              const parsedTaxInfo = JSON.parse(
                response.data.orderHeader.attribute57,
              );
              setTaxInfo(parsedTaxInfo);
            } catch (e) {}
          }
          setOrderHeaderRef({ ...response?.data?.orderHeaderRef });
          setDataPayment(response?.data?.paymentCommands);
          setListAdd(response.data.orderDetail);
          setOrderStatus(response?.data?.orderHeader?.orderStatus);
        }
      }
    };

    handleViewSalesOrder();
  }, [location]);

  // logic build pc

  useEffect(() => {
    if (orderHeader?.attribute19) {
      setListAdd((prevData) => {
        return prevData.map((item, i) => {
          return { ...item, attribute15: "1" };
        });
      });
      isFetchDataCalledRef.current = true;
    }
  }, [orderHeader?.attribute19]);

  // logic thanh toan sau
  useEffect(() => {
    const handlePayLaterMethodChange = (method: string) => {
      setPayLaterMethod(method);

      // Reset thông tin trả góp hoặc công nợ nếu phương thức thanh toán khác được chọn
      if (method !== "Trả góp") {
        setInstallmentInfo({
          installmentType: "",
          companyName: "",
          contractCode: "",
          cardType: "",
        });
      }
      if (method !== "Công nợ") {
        setDebtInfo({
          dueDate: "",
        });
      }
    };
    handlePayLaterMethodChange(payLaterMethod);
  }, [payLaterMethod]);

  useEffect(() => {
    if (
      location?.state?.actionType !== "payment" &&
      location?.state?.actionType !== "view" &&
      location?.state?.actionType !== "approved"
    ) {
      // Reset shippingVendor khi shipping thay đổi
      setShipingVendor("");

      // Cập nhật deliveryFee về 0
      setDataDeliveryInformation((prev: any) => {
        if (!prev) return prev; // Kiểm tra nếu prev là null hoặc undefined
        return {
          ...prev,
          deliveryFee: 0, // Cập nhật deliveryFee về 0
        };
      });
    }
  }, [shipping, location?.state?.actionType]);

  useEffect(() => {
    if (shipping === "Nhận tại cửa hàng") {
      setDataDeliveryInformation({
        ...dataDeliveryInformation,
        typeShip: "",
        shippingVendor: "",
      });
      setIsHaveShipping(false);
    }
  }, [shipping]);

  // Thêm ở đầu component (trước return hoặc trong component cha)
  const [buyerPopoverOpened, setBuyerPopoverOpened] = React.useState(false);
  const handleCopyBuyer = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  console.log("saleChanelList", saleChanelList);

  return (
    <Box>
      <div
        style={{
          ...getStyle(true),
        }}
      >
        {titleSell()}
      </div>
      {/* <Counter></Counter> */}
      <PanelGroup direction="horizontal" id="group" style={{ width: "100%" }}>
        <Panel
          defaultSize={
            isCollapse ? 0 : location?.state?.actionType === "view" ? 35 : 45
          }
          minSize={isCollapse ? 0 : 35}
          maxSize={65}
          collapsible
          style={{
            transition: "0.3s ease",
            display: isCollapse ? "none" : "block",
          }}
        >
          <Collapse
            in={!isCollapse}
            transitionDuration={100}
            transitionTimingFunction="ease-in-out"
            h={"100%"}
          >
            <Card h="100%" p={0} shadow="sm" radius="md" withBorder>
              {formOrderHeader()}
            </Card>
          </Collapse>
        </Panel>

        {!isCollapse && <PanelResizeHandle id="resize-handle" />}

        <Panel
          defaultSize={isCollapse ? 100 : 55}
          minSize={35}
          maxSize={isCollapse ? 100 : 65}
          style={{
            width: isCollapse ? "100%" : "auto",
            transition: "width 0.3s ease",
          }}
        >
          <Flex direction={"column"}>
            <MantineReactTable table={table} />

            {/* Thêm thanh hiển thị thông tin đơn hàng ở đây */}
            {!containsDT(orderHeader?.orderNumber) &&
              // !location?.state?.isReadOnly && (
              true && (
                <Card
                  shadow="sm"
                  radius="md"
                  withBorder
                  p="md"
                  style={{
                    backgroundColor: "#f9f9f9",
                    borderRadius: "10px",
                    padding: "20px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Grid>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Số lượng:
                      </Text>
                      <Text className={styles.infoValueStyle}>
                        {getTotalQuality(listAdd)}
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng tiền hàng:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={totalAmount}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Giảm giá:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={Math.abs(totalPromotionOrder)}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Sau giảm giá:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={amountAfterDiscount}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng phí sàn :
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={
                            totalFloorFee === 0
                              ? 0
                              : `-${Math.abs(totalFloorFee)}`
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Phí sàn cập nhật sau:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={
                            floorFeeAfter === 0
                              ? 0
                              : `-${Math.abs(floorFeeAfter)}`
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                    {/* <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng xin giảm:
                      </Text>
                      <Text fw={"bold"}>
                        <NumberFormatter
                          value={
                            (totalXGDetail ?? 0) +
                              (orderHeader?.discountAddedTotal ?? 0) ===
                            0
                              ? 0
                              : `-${
                                  (totalXGDetail ?? 0) +
                                  (orderHeader?.discountAddedTotal ?? 0)
                                }`
                          }
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col> */}
                    <Grid.Col span={2} className={styles.orderInfoStyle}>
                      <Text fw={500} className={styles.infoLabelStyle}>
                        Tổng tiền cần thanh toán:
                      </Text>
                      <Text fw={"bold"} style={{ color: "red" }}>
                        <NumberFormatter
                          value={payableAmount}
                          thousandSeparator="."
                          decimalSeparator=","
                        />
                      </Text>
                    </Grid.Col>
                  </Grid>
                </Card>
              )}
          </Flex>
        </Panel>
      </PanelGroup>
      <Box display={"none"}>
        <PrintInvoice
          isDVT={
            listBranch?.find(
              (item: any) => Number(item.value) === Number(branchId),
            )?.attr6 === "DVT"
          }
          idPrint={idPrint}
          setIdPrint={setIdPrint}
          isPrinting={isPrinting}
          setIsPrinting={setIsPrinting}
          orderNumber={orderHeader.orderNumber}
          // price={bankTransfer + anotherPayment || getPayAmountByPayType("01")}
          price={deferredPayment - orderHeader?.amountPaid}
          buyerName={orderHeader?.attribute36}
        />
      </Box>
      <Box>
        <WarehouseSelector
          opened={opened2}
          setOpened={setOpened2}
          selectedWarehouse={selectedWarehouse}
          setSelectedWarehouse={setSelectedWarehouse}
          warehouseList={warehouseList}
        />

        {/* Hiển thị kho đã chọn */}
        {selectedWarehouse && (
          <Box mt="md">
            <Text size="sm" c="teal">
              <b>Kho đã chọn:</b> {selectedWarehouse.subInvName} (
              {selectedWarehouse.branchName})
            </Text>
          </Box>
        )}

        {/* Customer Edit Modal */}
        <Modal
          opened={editCustomerModalOpened}
          onClose={() => setEditCustomerModalOpened(false)}
          title="Chỉnh sửa thông tin khách hàng"
          size="md"
          centered
        >
          <Box>
            <Grid>
              <Grid.Col span={12}>
                <TextInput
                  label="Tên khách hàng"
                  placeholder="Nhập tên khách hàng"
                  value={editCustomerData.name}
                  onChange={(e) =>
                    setEditCustomerData((prev) => ({
                      ...prev,
                      name: e.currentTarget.value,
                    }))
                  }
                  withAsterisk
                />
              </Grid.Col>

              <Grid.Col span={12}>
                <TextInput
                  label="Số điện thoại"
                  placeholder="Nhập số điện thoại"
                  value={editCustomerData.telephoneNumber}
                  onChange={(e) =>
                    setEditCustomerData((prev) => ({
                      ...prev,
                      telephoneNumber: e.currentTarget.value,
                    }))
                  }
                  withAsterisk
                />
              </Grid.Col>

              <Grid.Col span={12}>
                <Select
                  label="Tỉnh/Thành phố"
                  placeholder="Chọn tỉnh/thành phố"
                  data={dataProvinces}
                  value={editCustomerData.provinceId}
                  onChange={(value) => {
                    setEditCustomerData((prev) => ({
                      ...prev,
                      provinceId: value || "",
                      wardId: "", // Reset ward when province changes
                    }));
                    if (value) {
                      loadWards(value);
                    }
                  }}
                  searchable
                  clearable
                  withAsterisk
                />
              </Grid.Col>

              <Grid.Col span={12}>
                <Select
                  label="Phường/Xã"
                  placeholder="Chọn phường/xã"
                  data={dataWards}
                  value={editCustomerData.wardId}
                  onChange={(value) =>
                    setEditCustomerData((prev) => ({
                      ...prev,
                      wardId: value || "",
                    }))
                  }
                  searchable
                  clearable
                  withAsterisk
                  disabled={!editCustomerData.provinceId}
                />
              </Grid.Col>

              <Grid.Col span={12}>
                <TextInput
                  label="Địa chỉ chi tiết"
                  placeholder="Nhập địa chỉ chi tiết"
                  value={editCustomerData.address}
                  onChange={(e) =>
                    setEditCustomerData((prev) => ({
                      ...prev,
                      address: e.currentTarget.value,
                    }))
                  }
                  withAsterisk
                />
              </Grid.Col>
            </Grid>

            <Group justify="end" mt="md">
              <Button
                variant="outline"
                onClick={() => setEditCustomerModalOpened(false)}
              >
                Hủy
              </Button>
              <Button
                onClick={handleSaveCustomerEdit}
                disabled={
                  !editCustomerData.name ||
                  !editCustomerData.telephoneNumber ||
                  !editCustomerData.address ||
                  !editCustomerData.provinceId ||
                  !editCustomerData.wardId
                }
              >
                Lưu
              </Button>
            </Group>
          </Box>
        </Modal>

        {/* Modal thông tin xuất hóa đơn VAT */}
        <Modal
          opened={taxInfoModalOpened}
          onClose={() => {
            if (location?.state?.actionType === "view") {
              setTaxInfoModalOpened(false);
              return;
            }

            if (orderHeader?.printInvoiceCheck === 1) {
              if (emailError) {
                NotificationExtension.Warn(
                  "Email không đúng định dạng. Vui lòng kiểm tra lại!",
                );
                return;
              }
            }

            setTaxInfoModalOpened(false);
          }}
          title="Thông tin xuất hóa đơn VAT"
          size="70vw"
          centered
          closeOnClickOutside={false}
          closeOnEscape={false}
        >
          <Grid>
            <Grid.Col span={6}>
              <TextInput
                label="Mã số thuế"
                size="lg"
                placeholder="Nhập mã số thuế"
                value={taxInfo.TaxCode}
                rightSection={
                  <ActionIcon
                    disabled={
                      !taxInfo.TaxCode ||
                      String(taxInfo.TaxCode).length < 8 ||
                      timeOutCallApi
                    }
                    onClick={() => handleSearchTax()}
                  >
                    <IconSearch size={18} />
                  </ActionIcon>
                }
                variant={
                  location?.state?.actionType === "view" ? "filled" : "default"
                }
                readOnly={location?.state?.actionType === "view"}
                withAsterisk
                styles={{
                  input: {
                    fontSize: "16px",
                    color:
                      location?.state?.actionType === "view"
                        ? "#000 !important"
                        : undefined,
                    opacity:
                      location?.state?.actionType === "view" ? 1 : undefined,
                  },
                  label: {
                    fontSize: "15px",
                    fontWeight: 500,
                  },
                }}
                onChange={(e) => {
                  const newTaxInfo = { ...taxInfo, TaxCode: e.target.value };
                  setTaxInfo(newTaxInfo);
                  setOrderHeader((prev: any) => ({
                    ...prev,
                    attribute57: JSON.stringify(newTaxInfo),
                  }));
                }}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <TextInput
                label="Tên công ty"
                size="lg"
                placeholder="Nhập tên công ty"
                value={taxInfo.TaxCompany}
                variant={
                  location?.state?.actionType === "view" ? "filled" : "default"
                }
                readOnly={location?.state?.actionType === "view"}
                withAsterisk
                styles={{
                  input: {
                    fontSize: "16px",
                    color:
                      location?.state?.actionType === "view"
                        ? "#000 !important"
                        : undefined,
                    opacity:
                      location?.state?.actionType === "view" ? 1 : undefined,
                  },
                  label: {
                    fontSize: "15px",
                    fontWeight: 500,
                  },
                }}
                onChange={(e) => {
                  const newTaxInfo = { ...taxInfo, TaxCompany: e.target.value };
                  setTaxInfo(newTaxInfo);
                  setOrderHeader((prev: any) => ({
                    ...prev,
                    attribute57: JSON.stringify(newTaxInfo),
                  }));
                }}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <TextInput
                label="Email nhận hóa đơn"
                size="lg"
                placeholder="Nhập email"
                value={taxInfo.TaxEmail}
                variant={
                  location?.state?.actionType === "view" ? "filled" : "default"
                }
                readOnly={location?.state?.actionType === "view"}
                withAsterisk
                error={emailError}
                styles={{
                  input: {
                    fontSize: "16px",
                    color:
                      location?.state?.actionType === "view"
                        ? "#000 !important"
                        : undefined,
                    opacity:
                      location?.state?.actionType === "view" ? 1 : undefined,
                  },
                  label: {
                    fontSize: "15px",
                    fontWeight: 500,
                  },
                }}
                onChange={(e) => {
                  const emailValue = e.target.value;
                  const newTaxInfo = { ...taxInfo, TaxEmail: emailValue };

                  // Validate email format
                  const emailRegex =
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                  if (emailValue && !emailRegex.test(emailValue)) {
                    setEmailError("Email không đúng định dạng");
                  } else {
                    setEmailError("");
                  }

                  setTaxInfo(newTaxInfo);
                  setOrderHeader((prev: any) => ({
                    ...prev,
                    attribute57: JSON.stringify(newTaxInfo),
                    attribute53: emailValue,
                  }));
                  setVatEmailList(emailValue);
                }}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <TextInput
                label="Địa chỉ công ty"
                size="lg"
                placeholder="Nhập địa chỉ"
                value={taxInfo.TaxAddress}
                variant={
                  location?.state?.actionType === "view" ? "filled" : "default"
                }
                readOnly={location?.state?.actionType === "view"}
                withAsterisk
                styles={{
                  input: {
                    fontSize: "16px",
                    color:
                      location?.state?.actionType === "view"
                        ? "#000 !important"
                        : undefined,
                    opacity:
                      location?.state?.actionType === "view" ? 1 : undefined,
                  },
                  label: {
                    fontSize: "15px",
                    fontWeight: 500,
                  },
                }}
                onChange={(e) => {
                  const addressValue = e.target.value;
                  const newTaxInfo = { ...taxInfo, TaxAddress: addressValue };
                  setTaxInfo(newTaxInfo);
                  setOrderHeader((prev: any) => ({
                    ...prev,
                    attribute57: JSON.stringify(newTaxInfo),
                  }));
                }}
              />
            </Grid.Col>
          </Grid>
        </Modal>
      </Box>
    </Box>
  );
};

export default OrderDetailTMĐT;
